(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7144],{

/***/ 15205:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/flights_logo_bumper-d50e85578b4057f5acfd3ea9f695c3c1.jpg";

/***/ }),

/***/ 83326:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/hotel-image-2x-fc0bd41826c469f5201dab630a4d3b9b.jpg";

/***/ }),

/***/ 17544:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/hotel-image-tablet-2x-bbc460b6a651e02c2fa848e188984b59.jpg";

/***/ }),

/***/ 14625:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/hotel-vip-promo-2x-452c87786a4ab815f4cea24f3c4de0c6.jpg";

/***/ }),

/***/ 45626:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/marketing-tout-3f2bcb795a32a37449d9217f566105d1.jpg";

/***/ }),

/***/ 68988:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/One-635a492d0b64f53be39e1cab9c120f89.svg";

/***/ }),

/***/ 78636:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";

/***/ }),

/***/ 94863:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/Two-43f2bfbd4854c2d779530dca660b1708.svg";

/***/ }),

/***/ 34696:
/***/ (function(module) {

module.exports = "https://assets.pclncdn.com/web/next-landing/b725441d49/_next/static/images/rcBumper-9f864eebd1867e65bb8f5bced2341195.png";

/***/ }),

/***/ 90020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CrossSell; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(92300);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@pcln/config/client.js
var client = __webpack_require__(1918);
var client_default = /*#__PURE__*/__webpack_require__.n(client);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/FlightsFill.js
var FlightsFill = __webpack_require__(75749);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CarsFill.js
var CarsFill = __webpack_require__(40165);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/utils/clean-slashes.ts
function cleanSlashes(urlString) {
    return urlString.replace(/(^\/)|(\/$)/g, "");
}

;// CONCATENATED MODULE: ./src/components/CrossSell/types.ts
var Product = {
    Flight: 1,
    Hotel: 5,
    Car: 8
};

;// CONCATENATED MODULE: ./src/components/CrossSell/utils.ts











var _hosts;
var hosts = (_hosts = (client_default()).hosts) !== null && _hosts !== void 0 ? _hosts : {};
var baseUrl = hosts.baseUrl || "/";
var baseUrlSecure = hosts.baseUrlSecure || "/";
var _services;
var services = (_services = (client_default()).services) !== null && _services !== void 0 ? _services : {};
var itineraryServiceConfig = (config_default()).client["itinerary-service"];
var getLinkUri = function(serviceName, endpoint) {
    var service = services[serviceName];
    if (!service) {
        throw new Error("service ".concat(serviceName, " not configured"));
    }
    var base = service.secure ? baseUrlSecure : baseUrl;
    return "".concat(cleanSlashes(base), "/").concat(cleanSlashes(service.uri)).concat(endpoint ? "/".concat(cleanSlashes(endpoint)) : "");
};
var PCLN_ITINERARY_SERVICE_URL = itineraryServiceConfig.url || getLinkUri("itinerary-service", "graph");
var PCLN_ITINERARY_SERVICE_TIMEOUT = itineraryServiceConfig.timeout;
var serviceOptions = {
    url: PCLN_ITINERARY_SERVICE_URL,
    method: "POST",
    timeout: PCLN_ITINERARY_SERVICE_TIMEOUT
};
function buildContent(booking) {
    var startDate = (0,parseISO/* default */.Z)(booking.travelStartDateTime);
    var endDate = (0,parseISO/* default */.Z)(booking.travelEndDateTime);
    var formattedDate = "".concat((0,format/* default */.Z)(startDate, "EEE, MMM dd"), " - ").concat((0,format/* default */.Z)(endDate, "EEE, MMM dd"));
    var hotelsXSellUrl = function(destination, start, end) {
        return "/relax/in/".concat(destination, "/from/").concat((0,format/* default */.Z)(start, "yyyyMMdd"), "/to/").concat((0,format/* default */.Z)(end, "yyyyMMdd"), "/rooms/1");
    };
    switch(booking.productId){
        case Product.Hotel:
            {
                var checkInDate = (0,parseISO/* default */.Z)(booking.utcCheckInDateTime);
                return {
                    product: "hotel",
                    xSellMessaging: "Your hotel booking unlocks up to 40% off rental cars",
                    xSellTarget: "Rental Cars",
                    date: formattedDate,
                    offerToken: booking.offerToken,
                    headline: booking.destinationCity,
                    subHeadline: "Check-in on ".concat((0,format/* default */.Z)(checkInDate, "EEE, MMM dd")),
                    xSellUrl: "/drive/search/r/".concat(booking.destinationCity, ",").concat(booking.destinationCountryCode, "/").concat(booking.destinationCity, ",").concat(booking.destinationCountryCode, "/").concat((0,format/* default */.Z)(startDate, "yyyyMMdd"), "-12:00/").concat((0,format/* default */.Z)(endDate, "yyyyMMdd"), "-12:00/list")
                };
            }
        case Product.Flight:
            {
                var destination = booking.destinationCity || booking.destinationLocationCode;
                var isSameDay = (0,differenceInCalendarDays/* default */.Z)(endDate, startDate) < 1;
                return {
                    product: "flight",
                    xSellMessaging: "Your flight booking unlocks VIP hotel deals of up to 40% off",
                    xSellTarget: "Hotels",
                    offerToken: booking.offerToken,
                    date: formattedDate,
                    headline: "".concat(booking.originLocationCode, " - ").concat(booking.destinationLocationCode),
                    subHeadline: "Departs ".concat((0,format/* default */.Z)(startDate, "EEE, MMM dd 'at' h:mm a")),
                    xSellUrl: hotelsXSellUrl(destination, startDate, isSameDay ? (0,addDays/* default */.Z)(endDate, 1) : endDate)
                };
            }
        case Product.Car:
            {
                var checkInDate1 = (0,parseISO/* default */.Z)(booking.utcCheckInDateTime);
                return {
                    product: "car",
                    xSellMessaging: "Your rental car booking unlocks VIP hotel deals of up to 40% off",
                    xSellTarget: "Hotels",
                    offerToken: booking.offerToken,
                    date: formattedDate,
                    headline: "".concat(booking.destinationCity),
                    subHeadline: "Pickup on ".concat((0,format/* default */.Z)(checkInDate1, "EEE, MMM do")),
                    xSellUrl: hotelsXSellUrl(booking.destinationCity, startDate, endDate)
                };
            }
    }
}
function buildRCInventoryRequest(param) {
    var pickupDateTime = param.pickupDateTime, returnDateTime = param.returnDateTime, pickupLocation = param.pickupLocation, returnLocation = param.returnLocation, offerToken = param.offerToken, tokenType = param.tokenType;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            query: '{\n        rcXsell(\n          pickupDateTime: "'.concat(pickupDateTime, '",\n          returnDateTime: "').concat(returnDateTime, '",\n          pickupLocation: "').concat(pickupLocation, '",\n          returnLocation: "').concat(returnLocation, '",\n          offerToken: "').concat(offerToken, '",\n          tokenType: "').concat(tokenType, '"\n        ) {\n          listings: content {\n            id\n            checkoutUrl\n            carExample\n            isCarExampleExact\n            pricing {\n              price\n              currencySymbol\n              disclaimer\n              priceDescription\n            }\n            partner {\n              name\n              url\n            }\n            options\n            bannerType\n            carImageUrl\n            vehicleFeatures {\n              bagCapacity\n              isAirConditioned\n              isUnlimitedMileage\n              mileageDistance\n              mileageUnit\n              peopleCapacity\n            }\n            rate {\n              currencyCode\n              currencySymbol\n              dailyPrice\n              isFreeCancellation\n              isPrepay\n              savingsPriceTotal\n              strikeThroughPrice\n              totalPrice\n            }\n          }\n        }\n      }')
        }
    });
}
function buildHotelInventoryRequest(param) {
    var cityId = param.cityId, cityName = param.cityName, checkIn = param.checkIn, checkOut = param.checkOut, cguid = param.cguid, appc = param.appc, rid = param.rid, productId = param.productId, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 3 : _pageSize, dealTypes = param.dealTypes;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            variables: {
                cityId: cityId,
                cityName: cityName,
                checkIn: checkIn,
                checkOut: checkOut,
                cguid: cguid,
                appc: appc,
                rid: rid,
                productId: productId,
                pageSize: pageSize,
                dealTypes: dealTypes
            },
            query: "{\n        integratedListings(\n          cityId: ".concat(cityId, '\n          cityName: "').concat(cityName, '"\n          checkIn: ').concat(checkIn, "\n          checkOut: ").concat(checkOut, '\n          appc: "').concat(appc, '"\n          cguid: "').concat(cguid, '"\n          rid: "').concat(rid, '"\n          productId: ').concat(productId, "\n          pageSize: ").concat(pageSize, "\n        ) {\n          listings {\n            name\n            location\n            imageUrl\n            guestRating\n            guestReviewCount\n            starRating\n            savingPercentage\n            originalPrice\n            currentPrice\n            currency\n            currencySymbol\n            hotelId\n            href\n          }\n        }\n      }")
        }
    });
}
function buildItineraryDetailsRequest(offerToken, tokenType) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            query: '{\n        itineraryDetails(offerToken: "'.concat(offerToken, '", tokenType: "').concat(tokenType, '") {\n          hotelXsellCarousel {\n            checkIn\n            checkOut\n            cityId\n            cityName\n          }\n          rcXsellRequestParams {\n            pickupDateTime\n            returnDateTime\n            pickupLocation\n            returnLocation\n          }\n        }\n      }')
        }
    });
}
function trackCrossSellClicks() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box CTA",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell Choose Button"
    });
}
/**
 * This is needed because of the following scenarios
 *
 * view more button with inventory - example text is "view more rental car deals" - product is singular and lowercase
 * search button with no inventory - example text is "Search Rental Cars" - product is upper case and plural
 */ var X_SELL_PRODUCTS = {
    "Rental Cars": "rental car",
    Hotels: "hotel",
    Flights: "flight"
};
var trackViewTripClick = function() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box Link",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell View Trip"
    });
};
var getProductIconFilled = function(product) {
    switch(product){
        case "flight":
        case "Flights":
            return FlightsFill/* default */.Z;
        case "car":
        case "Rental Cars":
            return CarsFill/* default */.Z;
        default:
            return HotelsFill/* default */.Z;
    }
};
var getProductIcon = function(product) {
    switch(product){
        case "flight":
        case "Flights":
            return Flights;
        case "car":
        case "Rental Cars":
            return Cars;
        default:
            return Hotels;
    }
};

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Stamp/Stamp.js
var Stamp = __webpack_require__(57397);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Guests.js
var Guests = __webpack_require__(21404);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Luggage.js
var Luggage = __webpack_require__(26884);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Ac.js
var Ac = __webpack_require__(37516);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/FreeCancellation.js
var FreeCancellation = __webpack_require__(41269);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Mileage.js
var Mileage = __webpack_require__(6789);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
;// CONCATENATED MODULE: ./src/components/CrossSell/Common.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 185px;\n  width: 273px;\n  flex: 1 0;\n  background-color: ",
        ";\n  margin-right: 12px;\n  ",
        " {\n    margin-right: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid rgba(89, 107, 125, 0.5);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0;\n  width: 100px;\n  background-image: url(",
        ");\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 19px;\n  hyphens: auto;\n  display: -webkit-box;\n  -moz-box-orient: vertical;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.6em;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n  top: -0.5em;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ProductWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-49e058f2-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("background.lightest"), function(props) {
    return props.theme.mediaQueries[0];
});
var ProductFlexBorder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-49e058f2-1"
})(_templateObject1());
var ProductImage = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-49e058f2-2"
})(_templateObject2(), function(props) {
    return props.bgImage;
});
var ProductTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-3"
})(_templateObject3());
var PrimaryText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-4"
})(_templateObject4());
var SecondaryText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-5"
})(_templateObject5());
var StyledSup = styled_components_browser_esm/* default.sup.withConfig */.ZP.sup.withConfig({
    componentId: "sc-49e058f2-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/CrossSell/CarProduct.tsx

function CarProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  background-repeat: no-repeat;\n  background-size: contain;\n"
    ]);
    CarProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n"
    ]);
    CarProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CarProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 35px;\n  font-size: 12px;\n"
    ]);
    CarProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CarProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  min-height: 20px;\n  width: fit-content;\n  font-size: 10px;\n"
    ]);
    CarProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var CarImage = (0,styled_components_browser_esm/* default */.ZP)(ProductImage).withConfig({
    componentId: "sc-687492e7-0"
})(CarProduct_templateObject(), function(props) {
    return props.height;
});
var SmallText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-687492e7-1"
})(CarProduct_templateObject1());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-687492e7-2"
})(CarProduct_templateObject2());
var StyledStamp = (0,styled_components_browser_esm/* default */.ZP)(Stamp/* default */.Z).withConfig({
    componentId: "sc-687492e7-3"
})(CarProduct_templateObject3());
function CarProduct(param) {
    var carExample = param.carExample, carImageUrl = param.carImageUrl, checkoutUrl = param.checkoutUrl, offerId = param.offerId, rudderParentProductCode = param.rudderParentProductCode, url = param.partner.url, position = param.position, priceDescription = param.pricing.priceDescription, _rate = param.rate, currencySymbol = _rate.currencySymbol, dailyPrice = _rate.dailyPrice, isFreeCancellation = _rate.isFreeCancellation, savingsPriceTotal = _rate.savingsPriceTotal, totalPrice = _rate.totalPrice, _vehicleFeatures = param.vehicleFeatures, bagCapacity = _vehicleFeatures.bagCapacity, isAirConditioned = _vehicleFeatures.isAirConditioned, isUnlimitedMileage = _vehicleFeatures.isUnlimitedMileage, peopleCapacity = _vehicleFeatures.peopleCapacity;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    var vehicleFeature = function(Icon, text, isBold) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    size: 14,
                    mr: 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                    fontWeight: isBold ? "bold" : undefined,
                    children: text
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
        "data-event-type": "cross-sell",
        "data-rudder-event": true,
        "data-child-product": "car",
        "data-position": position,
        "data-has-inventory": true,
        "data-label": "Choose",
        "data-parent-product": rudderParentProductCode,
        "data-source": "homepage",
        "data-sub-type": "cross sell",
        "data-cguid": webstats.clientGUID,
        "data-email-address": customer.emailAddress,
        "data-parent-offer-id": offerId,
        className: "cross-sell-unit",
        borderRadius: "xl",
        borderWidth: 0,
        boxShadowSize: "sm",
        m: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductFlexBorder, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        ml: 2,
                        my: "5px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarImage, {
                                height: "58px",
                                borderRadius: "xl",
                                rounded: "topLeft",
                                bgImage: carImageUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                children: [
                                    vehicleFeature(Guests/* default */.Z, peopleCapacity, false),
                                    vehicleFeature(Luggage/* default */.Z, bagCapacity, false),
                                    isAirConditioned ? vehicleFeature(Ac/* default */.Z, "AC", false) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "172px",
                        px: 2,
                        py: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle, {
                                children: "Economy Car"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                                color: "text.light",
                                mb: 1,
                                children: carExample
                            }),
                            isFreeCancellation ? vehicleFeature(FreeCancellation/* default */.Z, "Free Cancellation", true) : null,
                            isUnlimitedMileage ? vehicleFeature(Mileage/* default */.Z, "Unlimited Mileage", true) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                px: 3,
                py: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStamp, {
                                        borderRadius: 2,
                                        bg: "alert",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                            color: "text.lightest",
                                            children: "PAY NOW & SAVE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallText, {
                                        style: {
                                            width: "fit-content"
                                        },
                                        mt: 1,
                                        children: [
                                            "Save",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    currencySymbol,
                                                    savingsPriceTotal
                                                ]
                                            }),
                                            " ",
                                            "by paying now"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 4,
                                        color: "secondary",
                                        fontWeight: "light",
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        fontSize: 4,
                                        color: "secondary",
                                        fontWeight: "bold",
                                        mr: 1,
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSup, {
                                                children: currencySymbol
                                            }),
                                            dailyPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                                        color: "secondary",
                                        children: priceDescription
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarImage, {
                                height: "35px",
                                bgImage: url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                alignItems: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        color: "text.light",
                                        children: [
                                            "Total: ",
                                            currencySymbol,
                                            totalPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
                                        onClick: trackCrossSellClicks,
                                        href: checkoutUrl,
                                        target: "_new",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                            color: "secondary",
                                            children: "Choose"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@pcln/vip/dist/esm/svgr/logos/LogoPricelineVip.js
var LogoPricelineVip = __webpack_require__(41188);
;// CONCATENATED MODULE: ./src/components/CrossSell/PricelineLogo.tsx


var PricelineLogo = function(param) {
    var _width = param.width, width = _width === void 0 ? "56px" : _width, _height = param.height, height = _height === void 0 ? "14px" : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#007AFF" : _fillColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 56 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "priceline_blue"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "priceline_blue",
                    fill: fillColor,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M4.1836476,3.12794981 C6.07565478,3.12794981 7.539747,4.5573853 7.539747,7.12419247 C7.539747,8.70170512 6.84377035,11.1523413 4.19758353,11.1523413 C3.34093383,11.1523413 2.89723847,10.87214 2.29020584,10.5029697 L2.29020584,13.6745617 L-5.68434189e-14,13.6745617 L-5.68434189e-14,3.33288533 L2.02562814,3.33288533 L2.02562814,4.05568187 C2.0989967,3.96712191 2.17277515,3.878971 2.24634865,3.80513695 C2.63102126,3.43535309 3.32556332,3.12794981 4.1836476,3.12794981 Z M51.853892,3.05597764 C52.3108005,3.05597764 53.6393938,3.09954365 54.6288849,4.16588334 C55.630443,5.24784104 55.6897552,6.75970481 55.7185932,7.63328546 L50.2170798,7.63328546 C50.2005133,8.59790264 50.7472081,9.56149231 51.9714938,9.56149231 C53.2107097,9.56149231 53.6393938,8.74524616 53.9187747,8.19738306 L55.630443,9.07116922 C55.3655834,9.47168879 55.0997011,9.85720686 54.7014912,10.2285454 C54.0380127,10.8507995 53.0346139,11.3250936 51.7945798,11.3250936 C49.5079922,11.3250936 47.8996089,9.85720686 47.8996089,7.32195291 C47.8996089,5.45498507 48.8140394,3.05597764 51.853892,3.05597764 Z M27.6735156,3.05597764 C28.1320255,3.05597764 29.4623991,3.09954365 30.4515465,4.16588334 C31.4527492,5.24784104 31.5120041,6.75970481 31.5426531,7.63328546 L26.0378773,7.63328546 C26.0231657,8.59790264 26.568719,9.56149231 27.7916166,9.56149231 C29.0341296,9.56149231 29.4623991,8.74524616 29.7435532,8.19738306 L31.4527492,9.07116922 C31.1881456,9.47168879 30.9229291,9.85720686 30.5249,10.2285454 C29.8616543,10.8507995 28.855752,11.3250936 27.615078,11.3250936 C25.3304969,11.3250936 23.7236688,9.85720686 23.7236688,7.32195291 C23.7236688,5.45498507 24.6378281,3.05597764 27.6735156,3.05597764 Z M21.0399034,3.14585934 C21.708428,3.14585934 22.7457797,3.29249573 23.6337954,4.11878666 C23.1455816,4.599713 22.8266016,5.20533155 22.6417779,5.83761126 C22.6366496,5.85770967 22.6001361,5.84663503 22.5861871,5.82161456 C22.4668004,5.58945737 22.3123361,5.36529852 22.0013563,5.14154985 C21.7789934,4.99368294 21.4975525,4.87555349 21.1432898,4.87555349 C19.9153707,4.87555349 19.500389,6.28059672 19.500389,7.21168652 C19.500389,8.23321919 20.0041928,9.51951771 21.2177527,9.51951771 C21.3350881,9.51951771 21.8983801,9.51951771 22.3722346,8.98711481 C22.4493642,8.89872281 22.5061857,8.81730372 22.551725,8.73629481 C22.5675201,8.7116845 22.6040336,8.70430141 22.6103927,8.72501508 C22.7984986,9.38087967 23.1273249,9.92394702 23.5667173,10.344168 C23.4616898,10.4403532 23.3462006,10.5365385 23.2149162,10.6294424 C22.6222903,11.044126 21.8682257,11.3250936 20.9958001,11.3250936 C19.5165944,11.3250936 17.1629118,10.4376871 17.1629118,7.2859276 C17.1629118,5.03736623 18.4650887,3.14585934 21.0399034,3.14585934 Z M44.6168467,3.14585934 C45.0743009,3.14585934 45.5878907,3.23279677 45.9867597,3.45125492 C46.7963373,3.87580949 47.0008751,4.5630002 47.0008751,5.74709202 L47.0008751,10.9655668 L44.749735,10.9655668 L44.749735,6.66793974 C44.749735,5.97993842 44.7342211,5.73270378 44.6462413,5.52741796 C44.4686486,5.1186702 44.0712085,4.94256618 43.6298805,4.94256618 C42.4884239,4.94256618 42.4387953,5.81178032 42.4366376,6.72002785 L42.4365395,10.9655668 L40.1704979,10.9655668 L40.1704979,3.34972659 L42.453074,3.34972659 L42.453074,4.0211105 C42.6733297,3.7870482 42.8205071,3.61216009 43.2179472,3.42207312 C43.5714995,3.27697476 44.0712085,3.14585934 44.6168467,3.14585934 Z M38.552777,3.32562273 L38.552777,10.9655668 L36.3059424,10.9655668 L36.3059424,3.32562273 L38.552777,3.32562273 Z M34.8679683,2.66453526e-15 L34.8679683,10.9655668 L32.5312603,10.9655668 L32.5312603,2.66453526e-15 L34.8679683,2.66453526e-15 Z M16.1743046,3.32562273 L16.1743046,10.9655668 L13.92747,10.9655668 L13.92747,3.32562273 L16.1743046,3.32562273 Z M12.9388628,3.23574104 L12.9388628,5.22548665 L12.1915803,5.34260215 C11.110302,5.53400581 10.7870541,5.69516648 10.7870541,6.66111562 L10.7870541,10.9655668 L8.53506701,10.9655668 L8.53506701,3.30840542 L10.7288533,3.30840542 L10.7288533,4.11278794 C11.2262981,3.68816815 11.768154,3.35184167 12.9388628,3.23574104 Z M3.82869131,4.73409616 C3.41368757,4.73409616 2.98536272,4.91162514 2.66053263,5.35422042 C2.3344729,5.78147621 2.18794072,6.44618723 2.18794072,7.16816566 C2.18794072,8.14171165 2.43960718,8.74710999 2.73410614,9.07128444 C3.00032335,9.35189476 3.38499596,9.51387972 3.75491287,9.51387972 C4.86281916,9.51387972 5.35098652,8.31903609 5.35098652,7.10885298 C5.35098652,6.09235644 5.07062844,5.01572911 4.13876571,4.77827388 C4.03527095,4.7498447 3.93198113,4.73409616 3.82869131,4.73409616 Z M51.8397798,4.68435994 C51.293494,4.68435994 50.9100099,4.95130448 50.6872824,5.18783503 C50.3790634,5.52917059 50.3050254,5.88489115 50.2318056,6.21081421 L53.3739206,6.21081421 C53.3303568,5.88489115 53.2698174,5.45498507 52.9460546,5.11467701 C52.6650375,4.83273096 52.2377851,4.68435994 51.8397798,4.68435994 Z M27.6592127,4.68435994 C27.1128421,4.68435994 26.7307504,4.95130448 26.5102815,5.18783503 C26.200726,5.52917059 26.1267596,5.88489115 26.0534061,6.21081421 L29.1963653,6.21081421 C29.1522306,5.88489115 29.0931801,5.45498507 28.7672784,5.11467701 C28.4869417,4.83273096 28.0580591,4.68435994 27.6592127,4.68435994 Z M37.5196399,0.179763391 C38.1889224,0.179763391 38.7325238,0.72309937 38.7325238,1.3933697 C38.7325238,2.06302977 38.1889224,2.60656917 37.5196399,2.60656917 C36.8493405,2.60656917 36.3059424,2.06302977 36.3059424,1.3933697 C36.3059424,0.72309937 36.8493405,0.179763391 37.5196399,0.179763391 Z M15.0498701,0.179763391 C15.7205977,0.179763391 16.264178,0.72309937 16.264178,1.3933697 C16.264178,2.06302977 15.7205977,2.60656917 15.0498701,2.60656917 C14.3801597,2.60656917 13.8375966,2.06302977 13.8375966,1.3933697 C13.8375966,0.72309937 14.3801597,0.179763391 15.0498701,0.179763391 Z",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M84.5 2a2.5 2.5 0 0 1 2.2 1.2c.2.4.3.8.3 1.3 0 .4-.1.9-.3 1.2a2.5 2.5 0 0 1-4.4 0c-.2-.3-.3-.7-.3-1.2 0-.4.1-.9.3-1.2A2.5 2.5 0 0 1 84.5 2zm0 4.4c.3 0 .7-.1 1-.3a2 2 0 0 0 .9-1.6 1.8 1.8 0 0 0-1-1.6c-.2-.2-.5-.3-.9-.3a1.8 1.8 0 0 0-1.6 1c-.2.2-.3.6-.3 1a1.9 1.9 0 0 0 1.9 1.8zm1-2.3v.4c-.1.2-.2.3-.4.3l.5.8H85l-.3-.7H84v.7h-.5V3.3h1c.3 0 .5 0 .7.2.2.1.3.3.3.6zm-1.4.4h.5l.3-.1V4v-.3H84v.7z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CrossSell_PricelineLogo = (PricelineLogo);

;// CONCATENATED MODULE: ./src/components/CrossSell/HotelProduct.tsx

function HotelProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 102px;\n"
    ]);
    HotelProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2px;\n"
    ]);
    HotelProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    HotelProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  height: 24px;\n  line-height: 1;\n"
    ]);
    HotelProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var HotelImage = (0,styled_components_browser_esm/* default */.ZP)(ProductImage).withConfig({
    componentId: "sc-10388aa2-0"
})(HotelProduct_templateObject());
var FeatureBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-10388aa2-1"
})(HotelProduct_templateObject1());
var LocationText = (0,styled_components_browser_esm/* default */.ZP)(SecondaryText).withConfig({
    componentId: "sc-10388aa2-2"
})(HotelProduct_templateObject2());
var StyledLogoPricelineVip = (0,styled_components_browser_esm/* default */.ZP)(LogoPricelineVip/* default */.Z).withConfig({
    componentId: "sc-10388aa2-3"
})(HotelProduct_templateObject3());
function HotelProduct(param) {
    var currencySymbol = param.currencySymbol, currentPrice = param.currentPrice, guestRating = param.guestRating, href = param.href, imageUrl = param.imageUrl, location = param.location, name = param.name, offerId = param.offerId, originalPrice = param.originalPrice, position = param.position, savingPercentage = param.savingPercentage, starRating = param.starRating, offerToken = param.offerToken, rudderParentProductCode = param.rudderParentProductCode;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
        "data-rudder-event": true,
        "data-child-product": "hotel",
        "data-position": position,
        "data-has-inventory": true,
        "data-label": "Choose",
        "data-parent-product": rudderParentProductCode,
        "data-source": "homepage",
        "data-sub-type": "cross sell",
        "data-cguid": webstats.clientGUID,
        "data-email-address": customer.emailAddress,
        "data-parent-offer-id": offerId,
        className: "cross-sell-unit",
        borderRadius: "xl",
        borderWidth: 0,
        boxShadowSize: "sm",
        m: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductFlexBorder, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelImage, {
                        borderRadius: "xl",
                        rounded: "topLeft",
                        bgImage: imageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "172px",
                        px: 3,
                        py: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle, {
                                mb: "6px",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationText, {
                                fontWeight: "bold",
                                color: "text.light",
                                mb: 2,
                                children: location
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBox, {
                                        mr: 2,
                                        color: "alert",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryText, {
                                            color: "text.lightest",
                                            px: "6px",
                                            fontWeight: "bold",
                                            children: guestRating
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        fontWeight: "bold",
                                        children: [
                                            starRating,
                                            "-Star Hotel"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                py: 2,
                flexDirection: "column",
                mb: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        px: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell_PricelineLogo, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoPricelineVip, {
                                px: 2,
                                variation: "vip"
                            }),
                            savingPercentage && savingPercentage > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrimaryText, {
                                color: "primary.dark",
                                px: "6px",
                                fontWeight: "bold",
                                children: [
                                    savingPercentage,
                                    "% off"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                px: 3,
                                children: [
                                    originalPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        fontWeight: "bold",
                                        children: [
                                            "was ",
                                            currencySymbol,
                                            originalPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "baseline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                                fontSize: 3,
                                                fontWeight: "bold",
                                                mr: 1,
                                                color: "primary.dark",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSup, {
                                                        children: currencySymbol
                                                    }),
                                                    currentPrice
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                                                color: "text.light",
                                                fontSize: 0,
                                                children: "per night"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
                                onClick: trackCrossSellClicks,
                                href: "".concat(href, "&xsellToken=").concat(offerToken),
                                target: "_new",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                    color: "secondary",
                                    mx: 1,
                                    children: "Choose"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/inventoryHelper.tsx








function fireEventForViewMoreDeals() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box CTA",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell View More Deals"
    });
}
function isCarListing(listing) {
    return listing.carExample !== undefined;
}
function renderXSellProduct(listing, position, offerId, offerToken, rudderParentProductCode) {
    if (isCarListing(listing)) {
        return /*#__PURE__*/ (0,react.createElement)(CarProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listing), {
            key: listing.id,
            offerId: offerId,
            position: position,
            rudderParentProductCode: rudderParentProductCode
        }));
    }
    return /*#__PURE__*/ (0,react.createElement)(HotelProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listing), {
        key: listing.hotelId,
        offerId: offerId,
        position: position,
        offerToken: offerToken,
        rudderParentProductCode: rudderParentProductCode
    }));
}
function renderXSellProducts(listings) {
    var numProducts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, offerId = arguments.length > 2 ? arguments[2] : void 0, offerToken = arguments.length > 3 ? arguments[3] : void 0, rudderParentProductCode = arguments.length > 4 ? arguments[4] : void 0;
    return listings.slice(0, numProducts).map(function(listing, index) {
        return renderXSellProduct(listing, index + 1, offerId, offerToken, rudderParentProductCode);
    });
}

// EXTERNAL MODULE: ./src/utils/rudder-stack.ts
var rudder_stack = __webpack_require__(964);
;// CONCATENATED MODULE: ./src/components/CrossSell/InventoryHeading.tsx



var Heading = function(param) {
    var xSellMessaging = param.xSellMessaging;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        color: "text.heading",
        textStyle: [
            "heading4",
            null,
            null,
            "heading5"
        ],
        children: xSellMessaging
    });
};
var HeadingNonXL = function(param) {
    var xSellMessaging = param.xSellMessaging, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "baseline",
        ml: [
            3,
            null,
            null,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                xSellMessaging: xSellMessaging
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 3,
                children: children
            })
        ]
    });
};
var HeadingXL = function(param) {
    var xSellMessaging = param.xSellMessaging, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "baseline",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                xSellMessaging: xSellMessaging
            }),
            children
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CrossSell/Inventory.tsx

function Inventory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: bold;\n"
    ]);
    Inventory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Inventory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto hidden;\n  & > :last-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    Inventory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ViewMoreDeals = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-3fc9c2d4-0"
})(Inventory_templateObject());
var ScrollContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3fc9c2d4-1"
})(Inventory_templateObject1(), (0,index_esm/* themeGet */.R)("space.1"));
function Inventory(param) {
    var xSellMessaging = param.xSellMessaging, xSellProduct = param.xSellProduct, rudderChildProductCode = param.rudderChildProductCode, rudderParentProductCode = param.rudderParentProductCode, xSellUrl = param.xSellUrl, listings = param.listings, offerId = param.offerId, offerToken = param.offerToken;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, webstats = ref.webstats, customer = ref.customer;
    (0,react.useEffect)(function() {
        (0,rudder_stack/* default */.Z)({
            label: "View more ".concat(xSellProduct, " deals"),
            parentProduct: rudderParentProductCode,
            childProduct: rudderChildProductCode,
            source: "homepage",
            subType: "cross sell",
            hasInventory: false,
            cguid: webstats.clientGUID,
            emailAddress: customer.emailAddress,
            parentOfferId: offerId,
            rudderEvent: true,
            category: "impression"
        });
    }, [
        xSellProduct,
        rudderParentProductCode,
        rudderChildProductCode,
        webstats.clientGUID,
        customer.emailAddress,
        offerId
    ]);
    var viewMoreDeals = function() {
        var target = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).target;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMoreDeals, {
            "data-cguid": webstats.clientGUID,
            "data-email-address": customer.emailAddress,
            "data-parent-offer-id": offerId,
            "data-label": "View more ".concat(xSellProduct, " deals"),
            "data-child-product": rudderChildProductCode,
            "data-parent-product": rudderParentProductCode,
            "data-has-inventory": listings.length > 1,
            "data-source": "homepage",
            "data-sub-type": "cross sell",
            "data-rudder-event": true,
            "data-view-more": true,
            onClick: fireEventForViewMoreDeals,
            href: xSellUrl,
            target: target,
            color: "primary",
            variation: "fill",
            py: 2,
            px: 3,
            children: [
                "View more ",
                xSellProduct,
                " deals"
            ]
        });
    };
    var renderedProducts = renderXSellProducts(listings, isMobile ? 2 : 3, offerId, offerToken, rudderParentProductCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hide/* default */.Z, {
                width: 8 / 11,
                mt: 40,
                ml: 24,
                xs: true,
                sm: true,
                md: true,
                lg: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingXL, {
                        xSellMessaging: xSellMessaging,
                        children: viewMoreDeals({
                            target: "_blank"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
                        "data-testid": "inventory-list",
                        mt: 12,
                        children: renderedProducts
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hide/* default */.Z, {
                width: [
                    1,
                    null,
                    2 / 3
                ],
                mt: [
                    24,
                    null,
                    3,
                    40
                ],
                ml: [
                    0,
                    null,
                    null,
                    24
                ],
                mb: [
                    0,
                    null,
                    null,
                    24
                ],
                xl: true,
                xxl: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingNonXL, {
                        xSellMessaging: xSellMessaging,
                        children: viewMoreDeals({
                            target: "_blank"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
                        mx: [
                            -3,
                            null,
                            null,
                            0
                        ],
                        px: [
                            3,
                            null,
                            null,
                            0
                        ],
                        mt: 24,
                        children: renderedProducts
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/NoInventoryFallback.tsx

function NoInventoryFallback_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    NoInventoryFallback_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NoInventoryFallback_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    NoInventoryFallback_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var NoInventoryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5c131fcf-0"
})(NoInventoryFallback_templateObject());
var InventoryTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5c131fcf-1"
})(NoInventoryFallback_templateObject1());
var TextSpan = Text/* default.span */.ZP.span;
function NoInventoryFallback(param) {
    var xSellMessaging = param.xSellMessaging, xSellTarget = param.xSellTarget, xSellUrl = param.xSellUrl, rudderChildProductCode = param.rudderChildProductCode, rudderParentProductCode = param.rudderParentProductCode, offerId = param.offerId, dataIsLoading = param.dataIsLoading;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    (0,react.useEffect)(function() {
        if (!dataIsLoading) {
            (0,rudder_stack/* default */.Z)({
                label: "Search ".concat(xSellTarget),
                parentProduct: rudderParentProductCode,
                childProduct: rudderChildProductCode,
                source: "homepage",
                subType: "cross sell",
                hasInventory: false,
                cguid: webstats.clientGUID,
                emailAddress: customer.emailAddress,
                parentOfferId: offerId,
                rudderEvent: true,
                category: "impression"
            });
        }
    }, [
        xSellTarget,
        rudderParentProductCode,
        rudderChildProductCode,
        webstats.clientGUID,
        customer.emailAddress,
        offerId,
        dataIsLoading
    ]);
    var ProductIcon = getProductIconFilled(xSellTarget || "hotel");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoInventoryWrapper, {
            "data-label": "Search ".concat(xSellTarget),
            "data-parent-product": rudderParentProductCode,
            "data-child-product": rudderChildProductCode,
            "data-source": "homepage",
            "data-sub-type": "cross sell",
            "data-has-inventory": false,
            "data-cguid": webstats.clientGUID,
            "data-email-address": customer.emailAddress,
            "data-parent-offer-id": offerId,
            "data-rudder-event": true,
            color: "background.lightest",
            borderRadius: "xl",
            py: 3,
            px: 24,
            width: [
                1,
                2 / 3,
                8 / 11
            ],
            "data-testid": "no-inventory-fallback",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                    xs: true,
                    sm: true,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "full",
                        mr: 4,
                        width: "80px",
                        height: "80px",
                        bg: (0,utils/* getPaletteColor */.ow)("background.lightest"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                            size: "32px"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InventoryTextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                    xxl: true,
                                    xl: true,
                                    lg: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "full",
                                        mr: 2,
                                        width: "56px",
                                        height: "56px",
                                        bg: (0,utils/* getPaletteColor */.ow)("background.lightest"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                                            size: "32px"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            color: "highlight.light",
                                            mr: "auto",
                                            px: 2,
                                            py: 1,
                                            borderRadius: "lg",
                                            mb: 2,
                                            display: "table",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                color: "highlight.shade",
                                                fontSize: 12,
                                                bold: true,
                                                children: "SAVE UP TO 40%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                            color: "text.heading",
                                            textStyle: [
                                                "heading5",
                                                null,
                                                "heading3"
                                            ],
                                            mb: 3,
                                            children: xSellMessaging
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                onClick: function() {
                                    analytics/* default.fireEvent */.Z.fireEvent({
                                        action: "Feature Box CTA",
                                        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                                        label: "Cross Sell Search Button"
                                    });
                                },
                                href: xSellUrl,
                                target: "_blank",
                                "data-testid": "XSELL_SEARCH_BUTTON",
                                variation: "fill",
                                children: [
                                    "Search ",
                                    xSellTarget
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/TripDetailsBox.tsx

function TripDetailsBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n"
    ]);
    TripDetailsBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ViewTripLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-ab66ffbd-0"
})(TripDetailsBox_templateObject());
function TripDetailsBox(param) {
    var product = param.product, headline = param.headline, subHeadline = param.subHeadline;
    var ProductIcon = getProductIconFilled(product || "hotel");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "full",
                        mr: 2,
                        minWidth: "56px",
                        minHeight: "56px",
                        bg: (0,utils/* getPaletteColor */.ow)("priceSecondary.light"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                            color: "primary.dark",
                            size: "32px",
                            mr: 2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        ml: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text",
                                textStyle: "heading4",
                                mb: 1,
                                children: headline
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text.base",
                                textStyle: "subheading6",
                                mt: 1,
                                children: subHeadline
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTripLink, {
                href: "/next-profile/trips",
                onClick: trackViewTripClick,
                variation: "fill",
                mt: 3,
                mr: "auto",
                width: 1,
                children: "View Trip"
            })
        ]
    });
}
/* harmony default export */ var CrossSell_TripDetailsBox = (TripDetailsBox);

;// CONCATENATED MODULE: ./src/components/CrossSell/BookingInfo.tsx





function BookingInfo(param) {
    var product = param.product, date = param.date, headline = param.headline, subHeadline = param.subHeadline;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _customer = ref.customer, _firstName = _customer.firstName, firstName = _firstName === void 0 ? "" : _firstName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        pt: [
            "24px",
            4
        ],
        pb: [
            3,
            4
        ],
        px: [
            3,
            "24px"
        ],
        flexDirection: "column",
        justifyContent: "center",
        width: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                textStyle: [
                    "heading3",
                    null,
                    null,
                    null,
                    "heading2"
                ],
                mb: 2,
                color: "text.heading",
                className: firstName ? "fs-mask" : "",
                children: [
                    firstName ? "".concat(firstName, ", your") : "Your ",
                    " trip is coming up!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "subheading5",
                color: "text.light",
                mb: "24px",
                children: date
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell_TripDetailsBox, {
                product: product,
                headline: headline,
                subHeadline: subHeadline
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);
;// CONCATENATED MODULE: ./src/components/CrossSell/useCrossSellInventory.ts









function getHotelItineraryDetails(offerToken) {
    return _getHotelItineraryDetails.apply(this, arguments);
}
function _getHotelItineraryDetails() {
    _getHotelItineraryDetails = (0,_async_to_generator/* default */.Z)(function(offerToken) {
        var itineraryResponse, _data, tmp, ref, _itineraryDetails, itineraryDetails, _hotelXsellCarousel;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        esm_default()(buildItineraryDetailsRequest(offerToken, "AES"))
                    ];
                case 1:
                    itineraryResponse = _state.sent();
                    _data = itineraryResponse.data, tmp = _data.data, ref = tmp === void 0 ? {} : tmp, _itineraryDetails = ref.itineraryDetails, itineraryDetails = _itineraryDetails === void 0 ? {} : _itineraryDetails;
                    return [
                        2,
                        (_hotelXsellCarousel = itineraryDetails.hotelXsellCarousel) !== null && _hotelXsellCarousel !== void 0 ? _hotelXsellCarousel : {}
                    ];
            }
        });
    });
    return _getHotelItineraryDetails.apply(this, arguments);
}
/**
 * Custom Hook to get XSell Inventory on client side, as it is done in a useEffect callback
 */ function useCrossSellInventory(booking) {
    var ref = (0,react.useState)({
        listings: [],
        offerId: booking.offerId || ""
    }), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref2.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, referral = ref2.referral, webstats = ref2.webstats;
    var cguid = webstats.clientGUID;
    (0,react.useEffect)(function() {
        function getXSell() {
            return _getXSell.apply(this, arguments);
        }
        function _getXSell() {
            _getXSell = (0,_async_to_generator/* default */.Z)(function() {
                var productType, pickupLocation, returnDateTime, pickupDateTime, offerToken, offerId, requestOptions, hotelItineraryDetails, _id, carInventoryParams, response, _data, _data1, integratedListings, rcXsell, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            productType = booking.productId, pickupLocation = booking.destinationCity, returnDateTime = booking.travelEndDateTime, pickupDateTime = booking.travelStartDateTime, offerToken = booking.secureToken, offerId = booking.offerId;
                            if (!(productType !== Product.Hotel)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                getHotelItineraryDetails(offerToken)
                            ];
                        case 1:
                            hotelItineraryDetails = _state.sent();
                            requestOptions = buildHotelInventoryRequest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotelItineraryDetails), {
                                appc: isMobile ? "MOBILE" : "DESKTOP",
                                rid: (_id = referral.id) !== null && _id !== void 0 ? _id : "",
                                productId: productType,
                                pageSize: isMobile ? 2 : 3,
                                dealTypes: false,
                                cguid: cguid
                            }));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            carInventoryParams = {
                                pickupDateTime: pickupDateTime,
                                returnDateTime: returnDateTime,
                                pickupLocation: pickupLocation,
                                returnLocation: pickupLocation,
                                offerToken: offerToken,
                                tokenType: "AES"
                            };
                            requestOptions = buildRCInventoryRequest(carInventoryParams);
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                esm_default()(requestOptions)
                            ];
                        case 4:
                            response = _state.sent();
                            _data = response.data, _data1 = _data.data, integratedListings = _data1.integratedListings, rcXsell = _data1.rcXsell;
                            if (productType === Product.Hotel) {
                                setData((rcXsell === null || rcXsell === void 0 ? void 0 : rcXsell.listings) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rcXsell), {
                                    offerId: offerId
                                }) : {
                                    listings: [],
                                    offerId: offerId
                                });
                            } else {
                                setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, integratedListings), {
                                    offerId: offerId
                                }));
                            }
                            return [
                                3,
                                7
                            ];
                        case 5:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.log("Failed to load inventory ");
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getXSell.apply(this, arguments);
        }
        getXSell();
    }, [
        booking,
        cguid,
        isMobile,
        referral.id
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        loading: loading
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/useCrossSellAnalytics.ts



var useCrossSellAnalytics = function(listings) {
    (0,react.useEffect)(function() {
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "xsell load",
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            label: "xsell display"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (listings.length > 1) {
            analytics/* default.fireEvent */.Z.fireEvent({
                action: "upcoming trip",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                label: "xsell inventory display"
            });
        }
    }, [
        listings.length
    ]);
};
/* harmony default export */ var CrossSell_useCrossSellAnalytics = (useCrossSellAnalytics);

;// CONCATENATED MODULE: ./src/components/CrossSell/CrossSell.tsx

function CrossSell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 4px solid ",
        ";\n"
    ]);
    CrossSell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-81e0a8c5-0"
})(CrossSell_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
function CrossSell(param) {
    var booking = param.booking;
    var ref = buildContent(booking), product = ref.product, date = ref.date, headline = ref.headline, offerToken = ref.offerToken, subHeadline = ref.subHeadline, xSellMessaging = ref.xSellMessaging, xSellTarget = ref.xSellTarget, xSellUrl = ref.xSellUrl;
    var xSellProduct = X_SELL_PRODUCTS[xSellTarget];
    var ref1 = useCrossSellInventory(booking), listings = ref1.listings, offerId = ref1.offerId, loading = ref1.loading;
    CrossSell_useCrossSellAnalytics(listings);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "cross-sell-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HighlightedFlex/* HighlightedFlex */.z, {
            shadowOffsetX: 24,
            shadowOffsetY: 24,
            maxWidth: 1216,
            flexDirection: [
                "column",
                null,
                "row"
            ],
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                    width: [
                        1,
                        null,
                        1 / 3,
                        null,
                        3 / 11
                    ],
                    color: "background.lightest",
                    boxShadowSize: "md",
                    borderRadius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInfo, {
                        product: product,
                        date: date,
                        headline: headline,
                        subHeadline: subHeadline
                    })
                }),
                offerId && (listings.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inventory, {
                    listings: listings,
                    offerId: offerId,
                    xSellMessaging: xSellMessaging,
                    xSellProduct: xSellProduct,
                    rudderParentProductCode: product,
                    rudderChildProductCode: xSellProduct,
                    xSellUrl: xSellUrl,
                    offerToken: offerToken
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoInventoryFallback, {
                    xSellMessaging: xSellMessaging,
                    xSellTarget: xSellTarget,
                    xSellUrl: xSellUrl,
                    rudderParentProductCode: product,
                    rudderChildProductCode: xSellProduct,
                    offerId: offerId,
                    dataIsLoading: loading
                }))
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/index.tsx



/***/ }),

/***/ 38292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ExtendStay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Badge/Badge.js
var Badge = __webpack_require__(72522);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/CalendarCheck.js
var CalendarCheck = __webpack_require__(21045);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/utils/get-hotel-link.ts

function getHotelLink(destination, start, end, numRooms) {
    return "/relax/at/".concat(destination, "/from/").concat((0,format/* default */.Z)(start, "yyyyMMdd"), "/to/").concat((0,format/* default */.Z)(end, "yyyyMMdd"), "/rooms/").concat(numRooms, "?iscalendaropen=true");
}

;// CONCATENATED MODULE: ./src/components/ExtendStay/utils.ts
var FASTLY_VALUES = {
    opto: true,
    crop: "261:261,offset-y100",
    auto: "webp"
};
function toQueryString(params) {
    var encodeFields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var queryStrings = Object.keys(params).map(function(key) {
        var encodeValue = encodeFields ? encodeURIComponent(params[key]) : params[key];
        return "".concat(key, "=").concat(encodeValue);
    });
    return queryStrings.join("&");
}
function generateHotelCoverPhotoUrl() {
    var hotelID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!hotelID) {
        return "";
    }
    var castedPropertyID = parseInt(hotelID, 10);
    var fPath = Math.floor(castedPropertyID / 100000);
    var sPath = Math.floor(castedPropertyID / 10000 - fPath * 10);
    var tPath = Math.floor(castedPropertyID / 1000 - (fPath * 10 + sPath) * 10);
    return "https://mobileimg.pclncdn.com/htlimg/master/".concat(fPath, "/").concat(sPath, "/").concat(tPath, "/").concat(hotelID, "/master_").concat(hotelID);
}
function generateThumbnailURL() {
    var hotelID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!hotelID) {
        return "";
    }
    var masterImageURL = generateHotelCoverPhotoUrl(hotelID);
    var fastlyQS = toQueryString(FASTLY_VALUES);
    return "".concat(masterImageURL, "?").concat(fastlyQS);
}
/* harmony default export */ var ExtendStay_utils = (generateThumbnailURL);

;// CONCATENATED MODULE: ./src/components/ExtendStay/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 4px solid ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var FlexWithTopBorder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
var CalendarIcon = (0,styled_components_browser_esm/* default */.ZP)(CalendarCheck/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-1"
})(_templateObject1());
var HotelsFillIcon = (0,styled_components_browser_esm/* default */.ZP)(HotelsFill/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-2"
})(_templateObject2());
var renderExtendStayButton = function(hotelID, endDate, numRooms) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: getHotelLink(hotelID, endDate, (0,addDays/* default */.Z)(endDate, 1), numRooms),
        onClick: function() {
            analytics/* default.fireEvent */.Z.fireEvent({
                action: "extend_trip",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG
            });
        },
        variation: "fill",
        target: "_blank",
        children: "Extend your Stay"
    });
};
function ExtendStay(param) {
    var travelEndDateTime = param.travelEndDateTime, cityName = param.cityName, hotelID = param.hotelID, _numRooms = param.numRooms, numRooms = _numRooms === void 0 ? 1 : _numRooms, title = param.title, customerFirstName = param.customerFirstName;
    var endDate = (0,parseISO/* default */.Z)(travelEndDateTime);
    var formattedEndDate = (0,format/* default */.Z)(endDate, "EEE, MMM dd");
    var image = ExtendStay_utils(hotelID);
    var trackViewTripClick = function() {
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "Feature Box Link",
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            label: "Cross Sell View Trip"
        });
    };
    var tripTitle = customerFirstName ? "".concat(customerFirstName, ", here are your trip details") : "Here are your trip details";
    var sectionTitle = "".concat(tripTitle, ",  Extend your hotel stay in ").concat(cityName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HighlightedFlex/* HighlightedFlex */.z, {
        shadowOffsetX: 24,
        shadowOffsetY: 24,
        maxWidth: "1216px",
        "aria-label": sectionTitle,
        flexDirection: [
            "column",
            null,
            "row"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWithTopBorder, {
                flexDirection: "column",
                width: [
                    1,
                    null,
                    null,
                    4 / 11,
                    3 / 11
                ],
                p: 3,
                borderRadius: "xl",
                boxShadowSize: "sm",
                justifyContent: "center",
                color: "background.lightest",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text.heading",
                        textStyle: "heading2",
                        mb: 3,
                        children: tripTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                width: "88px",
                                borderRadius: "xl",
                                src: image,
                                mr: 3,
                                alt: "Picture of ".concat(title, ", ").concat(cityName)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        mb: 1,
                                        textStyle: "heading5",
                                        children: "".concat(title, ", ").concat(cityName)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        textStyle: "subheading6",
                                        children: "Check-out on ".concat(formattedEndDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/next-profile/trips",
                        onClick: trackViewTripClick,
                        variation: "fill",
                        children: "View Trip"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                py: 2,
                width: [
                    1,
                    null,
                    null,
                    7 / 11,
                    8 / 11
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            sm: true,
                            md: true,
                            lg: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                bg: "background.lightest",
                                borderRadius: "full",
                                color: "success.dark",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                p: "24px",
                                m: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsFillIcon, {
                                    size: 5
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        ml: [
                            3,
                            null,
                            null,
                            null,
                            0
                        ],
                        mr: [
                            3,
                            null,
                            null,
                            1,
                            5
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge/* default */.Z, {
                                    bg: "highlight.light",
                                    color: "highlight.shade",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon, {
                                            size: "14px",
                                            mr: 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            pl: 3,
                                            children: "STAY LONGER"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                color: "text.heading",
                                mb: 3,
                                textStyle: [
                                    "heading4",
                                    null,
                                    null,
                                    "heading3"
                                ],
                                children: [
                                    "Extend your hotel stay in ",
                                    cityName,
                                    " & save even more with Priceline’s best available rates.*"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 4,
                                children: renderExtendStayButton(hotelID, endDate, numRooms)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text.base",
                                textStyle: "disclaimer",
                                children: "* This will be a separate reservation. Your current reservation will remain unchanged and in rare cases, the hotel may require you to move rooms."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 84469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExpressDealModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49034);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92591);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29293);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77185);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66487);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66410);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33765);
/* harmony import */ var _SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91753);
/* harmony import */ var _SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78393);













/**
 * TODO: Add fallback in StyleHeading, please refer
 * commit history for fallback text
 */ function ExpressDealModal(param) {
    var isModalOpen = param.isModalOpen, _gaCategory = param.gaCategory, gaCategory = _gaCategory === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_FLIGHTS */ .y1 : _gaCategory, _qsKey = param.qsKey, qsKey = _qsKey === void 0 ? "modal" : _qsKey, _qsValue = param.qsValue, qsValue = _qsValue === void 0 ? "express-deals" : _qsValue;
    var closeModal = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(qsKey, qsValue).closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isOpen: isModalOpen,
        onClose: closeModal,
        width: [
            1,
            750
        ],
        enableOverflow: true,
        timeout: 50,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            p: [
                3,
                0
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    px: [
                        0,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.headline */ .ZP.homepage.flights.expressDeals.headline,
                            fontSize: [
                                3,
                                null,
                                null,
                                5
                            ],
                            lineHeight: "display",
                            tag: "h1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.flights.expressDeals.subHeadline */ .ZP.homepage.flights.expressDeals.subHeadline,
                            fontSize: [
                                1,
                                null,
                                null,
                                4
                            ],
                            mb: 3,
                            lineHeight: "display",
                            tag: "h2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    pb: 4,
                    px: [
                        0,
                        3
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onSubmit: function(values) {
                            return (0,_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .onSubmitExpressDeal */ .pZ)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, values), {
                                gaCategory: gaCategory
                            }));
                        },
                        promoDeal: true,
                        flightTypes: [
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ROUND_TRIP */ .iF],
                            _constants__WEBPACK_IMPORTED_MODULE_6__/* .FLIGHT_TYPE_INFO */ .Yt[_constants__WEBPACK_IMPORTED_MODULE_6__/* .ONE_WAY */ .KW]
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 61094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PromoFeatureBox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Stamp/Stamp.js
var Stamp = __webpack_require__(57397);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./src/assets/images/promos/pricebreakers/One.svg
var One = __webpack_require__(68988);
var One_default = /*#__PURE__*/__webpack_require__.n(One);
// EXTERNAL MODULE: ./src/assets/images/promos/pricebreakers/Two.svg
var Two = __webpack_require__(94863);
var Two_default = /*#__PURE__*/__webpack_require__.n(Two);
// EXTERNAL MODULE: ./src/assets/images/promos/pricebreakers/Three.svg
var Three = __webpack_require__(78636);
var Three_default = /*#__PURE__*/__webpack_require__.n(Three);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./node_modules/pcln-modal/dist/esm/Modal.js + 69 modules
var Modal = __webpack_require__(49034);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/Form.tsx + 4 modules
var Form = __webpack_require__(68916);
;// CONCATENATED MODULE: ./src/components/Promos/Modal/PromoModal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    max-width: 100%;\n  }\n  // This is required for form elements like typeahead and calendar to work correctly in mobile view\n  button[title='close'] {\n    z-index: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-e061cc76-0"
})(_templateObject(), function(props) {
    return props.zIndex;
});
var handleTransition = function(transitionState) {
    return "\n  transition: transform 0.3s linear;\n  transform: ".concat(transitionState === "entered" ? "translateY(0px);" : "translateY(-120%);", "\n");
};
function PromoModal(param) {
    var ariaLabel = param.ariaLabel, isModalOpen = param.isModalOpen, onClose = param.onClose, isMobile = param.isMobile, primaryText = param.primaryText, secondaryText = param.secondaryText, onSubmit = param.onSubmit, promoDeal = param.promoDeal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
        enableOverflow: true,
        ariaLabel: ariaLabel,
        isOpen: isModalOpen,
        onClose: onClose,
        width: [
            1,
            750
        ],
        timeout: 50,
        dialogAnimation: isMobile ? handleTransition : undefined,
        imgMode: isMobile ? true : undefined,
        verticalAlignment: isMobile ? "top" : "middle",
        zIndex: isMobile ? 1 : undefined,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: [
                3,
                0
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: [
                    0,
                    3
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            3,
                            null,
                            null,
                            5
                        ],
                        fontWeight: "bold",
                        style: {
                            lineHeight: 1.25
                        },
                        children: primaryText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            1,
                            null,
                            null,
                            4
                        ],
                        style: {
                            lineHeight: 1.25
                        },
                        mb: 3,
                        children: secondaryText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            onSubmit: onSubmit,
                            promoDeal: promoDeal
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./src/components/Hotels/constants.ts
var constants = __webpack_require__(69722);
;// CONCATENATED MODULE: ./src/components/Promos/Pricebreakers/Pricebreakers.tsx
/* eslint-disable react/jsx-pascal-case */ 
function Pricebreakers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    height: 65px;\n    width: 224px;\n  }\n  ",
        " {\n    height: 48px;\n  }\n  font-size: 16px;\n  height: 48px;\n  margin-left: auto;\n  line-height: 22px;\n  padding: 0px;\n  width: 204px;\n"
    ]);
    Pricebreakers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  ",
        " {\n    flex: 1 1 50%;\n  }\n  ",
        " {\n    flex: 1 1 66%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  transform: translate(-14px, -8px) rotate(-28deg);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-a7f62daa-0"
})(Pricebreakers_templateObject(), function(props) {
    return props.theme.mediaQueries[0];
}, function(props) {
    return props.theme.mediaQueries[3];
});
var FlexWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a7f62daa-1"
})(_templateObject1(), function(props) {
    return props.theme.mediaQueries[0];
}, function(props) {
    return props.theme.mediaQueries[3];
});
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-a7f62daa-2"
})(_templateObject2());
var TiltStamp = (0,styled_components_browser_esm/* default */.ZP)(Stamp/* default */.Z).withConfig({
    componentId: "sc-a7f62daa-3"
})(_templateObject3());
function gaTracking() {
    analytics/* default.fireEvent */.Z.fireEvent({
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        action: "Feature Box CTA",
        label: "Hotel Collection Search"
    });
}
var icon1Content = "See 3 popular hotels at a heavily discounted price.";
var icon2Content = "Click choose and we’ll pick one of the 3 hotels.";
var icon3Content = "See which hotel right after you book!";
var InfoGraphic = function(param) {
    var children = param.children, contentText = param.contentText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        px: 1,
        flexDirection: [
            "row",
            "column"
        ],
        width: [
            1,
            1 / 2
        ],
        mt: [
            3,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                height: [
                    "56px",
                    "92px"
                ],
                mx: [
                    "none",
                    "auto"
                ],
                textAlign: "center",
                width: [
                    "56px",
                    "96px"
                ],
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                width: 1,
                ml: [
                    "11px",
                    "auto"
                ],
                mb: [
                    "auto",
                    0
                ],
                mt: [
                    "auto",
                    3
                ],
                textAlign: [
                    "left",
                    "center"
                ],
                fontSize: 1,
                fontWeight: [
                    600,
                    400
                ],
                children: contentText
            })
        ]
    });
};
var SearchButton = function(param) {
    var handleClick = param.handleClick, testId = param.testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
        color: "primary",
        variation: "subtle",
        "data-testid": testId,
        onClick: handleClick,
        children: "Search Pricebreakers"
    });
};
function PricebreakersPromo(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setModalOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        boxShadowSize: "md",
        mb: [
            4,
            null,
            0
        ],
        borderRadius: "xl",
        borderWidth: 0,
        width: [
            1,
            null,
            2 / 3
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    "row"
                ],
                style: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TiltStamp, {
                        color: "text.lightest",
                        bg: "warning",
                        children: "New"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                        p: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        color: "text",
                                        fontSize: [
                                            3,
                                            5
                                        ],
                                        fontWeight: "bold",
                                        children: [
                                            "Introducing",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default.span */.ZP.span, {
                                                color: "primary",
                                                children: " Pricebreakers"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                        xs: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                                            testId: "desktop-pricebreaker-button",
                                            handleClick: function() {
                                                setModalOpen(true);
                                                gaTracking();
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                style: {
                                    minHeight: "150px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    flexDirection: [
                                        "column",
                                        "row"
                                    ],
                                    mt: [
                                        0,
                                        4,
                                        3
                                    ],
                                    mb: [
                                        2,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoGraphic, {
                                            contentText: icon1Content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: (One_default()),
                                                alt: "",
                                                loading: "lazy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoGraphic, {
                                            contentText: icon2Content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: (Two_default()),
                                                alt: "",
                                                loading: "lazy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoGraphic, {
                                            contentText: icon3Content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: (Three_default()),
                                                alt: "",
                                                loading: "lazy"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                sm: true,
                                md: true,
                                lg: true,
                                xl: true,
                                xxl: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                                        testId: "mobile-pricebreaker-button",
                                        handleClick: function() {
                                            setModalOpen(true);
                                            gaTracking();
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {
                ariaLabel: "Pricebreakers Search Modal",
                primaryText: "Search Pricebreakers",
                secondaryText: "Our highest rated hotels - up to 50% off retail",
                isMobile: isMobile,
                isModalOpen: isModalOpen,
                onSubmit: utils/* handleSubmitForPricebreakers */.nz,
                onClose: function() {
                    setModalOpen(false);
                },
                promoDeal: constants/* PromoDeal.COLLECTIONS */.cS.COLLECTIONS
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MediaCard/MediaCard.js + 1 modules
var MediaCard = __webpack_require__(51100);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MoreInfo/MoreInfo.js
var MoreInfo = __webpack_require__(62818);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js + 3 modules
var ContentfulRichText = __webpack_require__(91378);
;// CONCATENATED MODULE: ./src/components/Promos/Modal/MoreInfoModal.tsx





var MoreInfoModal = function(param) {
    var heading = param.heading, paragraph = param.paragraph, body = param.body, disclaimer = param.disclaimer, primaryCallToAction = param.primaryCallToAction, secondaryCallToAction = param.secondaryCallToAction, isOpen = param.isOpen, handleClose = param.handleClose, isFullHeight = param.isFullHeight;
    var bodyContent = function() {
        if (body) {
            return body;
        }
        if (paragraph) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                body: paragraph
            });
        }
        return null;
    };
    var modalProps = {
        heading: heading,
        isFullHeight: isFullHeight,
        body: bodyContent(),
        disclaimer: disclaimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
            body: disclaimer
        }) : null,
        primaryCallToAction: primaryCallToAction,
        secondaryCallToAction: secondaryCallToAction,
        isOpen: isOpen,
        onClose: handleClose,
        withModal: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfo/* default */.Z, (0,_object_spread/* default */.Z)({}, modalProps));
};
/* harmony default export */ var Modal_MoreInfoModal = (MoreInfoModal);

;// CONCATENATED MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx








function MediaCardComponent(param) {
    var content = param.content;
    var ref;
    var heading = content.heading, overline = content.overline, subheading = content.subheading, media = content.media, primaryCallToAction = content.primaryCallToAction;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(), currentModalProps = ref2[0], setCurrentModalProps = ref2[1];
    var handleOpen = function(modalProps, gaTracking) {
        if ((gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label)) {
            var gaParams = {
                category: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category,
                action: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action,
                label: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label
            };
            analytics/* default.fireEvent */.Z.fireEvent(gaParams);
        }
        if (modalProps) {
            setCurrentModalProps(modalProps);
            setIsOpen(true);
        }
    };
    var handleClose = function() {
        setCurrentModalProps(undefined);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_MoreInfoModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentModalProps), {
                isFullHeight: false,
                isOpen: isOpen,
                handleClose: function() {
                    handleClose();
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                borderWidth: 0,
                width: [
                    1,
                    null,
                    1 / 2
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCard/* default */.Z, {
                    handleOpen: handleOpen,
                    asset: {
                        file: {
                            contentType: "Image",
                            details: {
                                image: {
                                    height: 200,
                                    width: 600
                                }
                            },
                            fileName: media === null || media === void 0 ? void 0 : (ref = media.file) === null || ref === void 0 ? void 0 : ref.fileName,
                            url: media === null || media === void 0 ? void 0 : media.file.url
                        },
                        title: media === null || media === void 0 ? void 0 : media.title
                    },
                    callToAction: primaryCallToAction,
                    heading: heading,
                    overline: overline,
                    subheading: subheading,
                    objectFit: "cover",
                    objectPosition: "top"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Promos/Pricebreakers/content.tsx






var modal = {
    contentTypeId: "modal",
    url: "",
    internalName: "modal",
    buttonText: "Search Pricebreakers",
    testId: "mobile-pricebreaker-button",
    ariaLabel: "Pricebreakers",
    analyticsTracking: {
        contentTypeId: "googleAnalyticsTracking",
        category: "PCLN_HOME",
        action: "Feature Box CTA",
        label: "Search VIP Deals"
    },
    modalContent: {
        contentTypeId: "modal",
        internalName: "modal",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: [
                3,
                0
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: [
                    0,
                    3
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            3,
                            null,
                            null,
                            5
                        ],
                        fontWeight: "bold",
                        style: {
                            lineHeight: 1.25
                        },
                        children: "Search Pricebreakers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            1,
                            null,
                            null,
                            4
                        ],
                        style: {
                            lineHeight: 1.25
                        },
                        mb: 3,
                        children: "Our highest rated hotels - up to 50% off retail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            onSubmit: utils/* handleSubmitForPricebreakers */.nz,
                            promoDeal: constants/* PromoDeal.COLLECTIONS */.cS.COLLECTIONS
                        })
                    })
                ]
            })
        })
    }
};
var CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "Save up to 50% off hotels with Pricebreakers",
    subheading: "See 3 popular hotels at a heavily discounted price. See 3 popular hotels at a heavily discounted price. See 3 popular hotels at a heavily discounted price.",
    media: {
        title: "pricebreakers image",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/Pricebreakers.jpg",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "Pricebreakers.jpg",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: modal
};
/* harmony default export */ var content = (CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/Pricebreakers/PriceBreakersMediaCard.tsx




function PriceBreakersMediaCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent, {
            content: content
        })
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BackgroundImage/BackgroundImage.js
var BackgroundImage = __webpack_require__(77072);
// EXTERNAL MODULE: ./node_modules/@pcln/vip/dist/esm/svgr/logos/LogoPricelineVip.js
var LogoPricelineVip = __webpack_require__(41188);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/assets/images/promos/hotel-vip-promo-2x.jpg
var hotel_vip_promo_2x = __webpack_require__(14625);
var hotel_vip_promo_2x_default = /*#__PURE__*/__webpack_require__.n(hotel_vip_promo_2x);
// EXTERNAL MODULE: ./src/constants/content.ts
var constants_content = __webpack_require__(66410);
;// CONCATENATED MODULE: ./src/components/Promos/VIP/VIPPromo.tsx

function VIPPromo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    flex: 1 1 50%;\n  }\n  ",
        " {\n    flex: 1 1 33%;\n  }\n"
    ]);
    VIPPromo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VIPPromo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  margin-bottom: 16px;\n  ",
        " {\n    flex: 1 1 50%;\n  }\n  @media screen and (min-width: 1440px) {\n    margin-bottom: 24px;\n  }\n"
    ]);
    VIPPromo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VIPPromo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: transparent;\n  background-position: top;\n  border-top-left-radius: 16px;\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  @media only screen and (max-width: 1023px) {\n    border-top-right-radius: 16px;\n    border-bottom-left-radius: 0px;\n  }\n  height: ",
        ";\n"
    ]);
    VIPPromo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VIPPromo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 250px;\n  background-color: white;\n"
    ]);
    VIPPromo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  height: 32px;\n  line-height: 1;\n  margin-bottom: 8px;\n  ",
        " {\n    font-size: 48px;\n    height: 48px;\n    margin-bottom: 12px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var FlexImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-12c9f02b-0"
})(VIPPromo_templateObject(), function(props) {
    return props.theme.mediaQueries[0];
}, function(props) {
    return props.theme.mediaQueries[3];
});
var FlexHeaderContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-12c9f02b-1"
})(VIPPromo_templateObject1(), function(props) {
    return props.theme.mediaQueries[3];
});
var VIPBackgroundImage = (0,styled_components_browser_esm/* default */.ZP)(BackgroundImage/* default */.Z).withConfig({
    componentId: "sc-12c9f02b-2"
})(VIPPromo_templateObject2(), function(props) {
    return props.isMobile ? "0px" : "16px";
}, function(props) {
    return props.isMobile ? "16px" : "0px";
}, function(props) {
    return props.isMobile ? "109px" : "inherit";
});
var VIPPromo_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-12c9f02b-3"
})(VIPPromo_templateObject3());
var StyledLogoPricelineVip = (0,styled_components_browser_esm/* default */.ZP)(LogoPricelineVip/* default */.Z).withConfig({
    componentId: "sc-12c9f02b-4"
})(_templateObject4(), function(props) {
    return props.theme.mediaQueries[3];
});
var DealButton = function(param) {
    var handleModalOpen = param.handleModalOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
        style: {
            width: "160px"
        },
        size: "medium",
        onClick: function() {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                action: "Feature Box CTA",
                label: "Search VIP Deals"
            });
            handleModalOpen();
        },
        "aria-label": "VIP Promo button",
        role: "button",
        children: "Search VIP Deals"
    });
};
function VIPPromo(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), firstName = ref.customer.firstName;
    /**
   * TODO: Add these values to contentful and add fallback values
   */ var headlineVIP = firstName ? constants_content/* default.homepage.vip.promo.headlineWithName.replace */.ZP.homepage.vip.promo.headlineWithName.replace("{firstName}", firstName) : constants_content/* default.homepage.vip.promo.headline */.ZP.homepage.vip.promo.headline;
    var ref1 = (0,react.useState)(false), isModalOpen = ref1[0], setModalOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VIPPromo_Wrapper, {
        boxShadowSize: "md",
        mx: [
            0,
            null,
            2
        ],
        mb: [
            4,
            null,
            0
        ],
        borderRadius: "xl",
        borderWidth: 0,
        width: [
            1,
            null,
            2 / 3
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    null,
                    "row"
                ],
                style: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPBackgroundImage, {
                            image: "".concat((hotel_vip_promo_2x_default()), "?opto&auto=webp"),
                            isMobile: isMobile
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        p: 3,
                        width: [
                            1,
                            null,
                            null,
                            null,
                            2 / 3
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoPricelineVip, {
                                variation: "vip"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexHeaderContentWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        color: "text.heading",
                                        fontSize: [
                                            3,
                                            null,
                                            null,
                                            null,
                                            "22px",
                                            4
                                        ],
                                        mb: 2,
                                        fontWeight: "bold",
                                        textStyle: "heading3",
                                        lineHeight: "display",
                                        className: firstName ? "fs-mask" : null,
                                        children: headlineVIP
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        color: "text",
                                        lineHeight: "display",
                                        textStyle: "subheading6",
                                        children: constants_content/* default.homepage.vip.promo.subHeadline */.ZP.homepage.vip.promo.subHeadline
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DealButton, {
                                handleModalOpen: function() {
                                    setModalOpen(true);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoModal, {
                ariaLabel: "VIP Deals Search Modal",
                primaryText: "Search VIP Deals",
                secondaryText: "Save more as a Priceline VIP",
                isMobile: isMobile,
                isModalOpen: isModalOpen,
                onSubmit: utils/* handleSubmitForVIPDeals */.ty,
                onClose: function() {
                    setModalOpen(false);
                },
                promoDeal: constants/* PromoDeal.VIP */.cS.VIP
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Promos/VIP/content.tsx






var content_modal = {
    contentTypeId: "modal",
    url: "",
    internalName: "modal",
    buttonText: "Search VIP Deals",
    ariaLabel: "Search VIP Deals",
    analyticsTracking: {
        contentTypeId: "googleAnalyticsTracking",
        category: "PCLN_HOME",
        action: "Feature Box CTA",
        label: "Search VIP Deals"
    },
    modalContent: {
        contentTypeId: "modal",
        internalName: "modal",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: [
                3,
                0
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: [
                    0,
                    3
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            3,
                            null,
                            null,
                            5
                        ],
                        fontWeight: "bold",
                        style: {
                            lineHeight: 1.25
                        },
                        children: "Search VIP Deals"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            1,
                            null,
                            null,
                            4
                        ],
                        style: {
                            lineHeight: 1.25
                        },
                        mb: 3,
                        children: "Save more as a Priceline VIP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            onSubmit: utils/* handleSubmitForVIPDeals */.ty,
                            promoDeal: constants/* PromoDeal.VIP */.cS.VIP
                        })
                    })
                ]
            })
        })
    }
};
var content_CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "",
    subheading: "'Book Priceline VIP deals for your exclusive savings",
    media: {
        title: "vip image",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/VIP.png",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "vip.png",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: content_modal
};
/* harmony default export */ var VIP_content = (content_CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/VIP/VIPPromoMediaCard.tsx






function VIPPromoMediaCard() {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), firstName = ref.customer.firstName;
    var headlineVIP = firstName ? constants_content/* default.homepage.vip.promo.headlineWithName.replace */.ZP.homepage.vip.promo.headlineWithName.replace("{firstName}", firstName) : constants_content/* default.homepage.vip.promo.headline */.ZP.homepage.vip.promo.headline;
    VIP_content.heading = headlineVIP;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent, {
            content: VIP_content
        })
    });
}

// EXTERNAL MODULE: ./src/components/ConditionalRender/index.tsx + 2 modules
var ConditionalRender = __webpack_require__(93314);
// EXTERNAL MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMobileTout.tsx
var IncredibleTileMobileTout = __webpack_require__(92533);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./src/hooks/useContent.ts
var useContent = __webpack_require__(63598);
;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/contentMediaCard.ts
var contentMediaCard_CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "10% off coupon",
    subheading: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    media: {
        title: "Incredible Tile Promo",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/IncredibleTile.jpg",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "IncredibleTile.jpg",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: undefined
};
/* harmony default export */ var contentMediaCard = (contentMediaCard_CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMediaCard.tsx






function IncredibleTile(param) {
    var contentFulFieldID = param.contentFulFieldID;
    var incredibleTilePromo = (0,useContentful/* default */.Z)(contentFulFieldID);
    var promo = (0,useContent/* default */.Z)(incredibleTilePromo);
    var hasContentfulData = promo != null;
    var mediaCardContent = hasContentfulData ? promo : contentMediaCard;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent, {
        content: mediaCardContent
    });
}

;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMobile.tsx





function IncredibleTileMobile(param) {
    var contentFulFieldID = param.contentFulFieldID;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* default */.ZP, {
        experimentCode: "MBL_HP_INCRED_TILE_MEDIA_CARD",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Original */.gg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTileMobileTout/* default */.Z, {
                    incredibleTileContentfulName: "incredibleTileMobile"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTile, {
                    contentFulFieldID: contentFulFieldID
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils_utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/getVariantContent/getVariantContent.js
var getVariantContent = __webpack_require__(57931);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/components/Promos/IncredibleTile/content.ts
var IncredibleTile_content = __webpack_require__(31266);
;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/IncredibleTile.tsx

function IncredibleTile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 6px solid ",
        ";\n  height: 100%;\n"
    ]);
    IncredibleTile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IncredibleTile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  height: 100%;\n  object-fit: cover;\n  object-position: -40px;\n  position: relative;\n  border-radius: 0px 12px 16px 0px;\n  right: 0;\n  background-color: #fff;\n"
    ]);
    IncredibleTile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IncredibleTile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-shrink: 0;\n  object-fit: cover;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #fff;\n"
    ]);
    IncredibleTile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function IncredibleTile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  min-height: 234px;\n  &:hover {\n    text-decoration: none !important;\n    color: inherit;\n    overflow: visible;\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 6px 0px,\n      rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;\n    border-width: 1px;\n    border-color: rgb(192, 202, 213);\n    border-image: initial;\n    border-radius: 16px;\n  }\n"
    ]);
    IncredibleTile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var FlexWithTopBorder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9206b94f-0"
})(IncredibleTile_templateObject(), function(props) {
    return (0,utils_utils/* getPaletteColor */.ow)(props.borderColor)(props);
});
var BackgroundImageOnRight = (0,styled_components_browser_esm/* default */.ZP)(BackgroundImage/* default */.Z).withConfig({
    componentId: "sc-9206b94f-1"
})(IncredibleTile_templateObject1());
var BackgroundImageOnTop = (0,styled_components_browser_esm/* default */.ZP)(BackgroundImage/* default */.Z).withConfig({
    componentId: "sc-9206b94f-2"
})(IncredibleTile_templateObject2());
var BoxLink = (0,styled_components_browser_esm/* default */.ZP)(BlockLink/* default */.Z).withConfig({
    componentId: "sc-9206b94f-3"
})(IncredibleTile_templateObject3());
var PromoBox = function(param) {
    var children = param.children, boxLink = param.boxLink, ariaLabel = param.ariaLabel, googleAnalyticsTrackingOnClick = param.googleAnalyticsTrackingOnClick;
    return boxLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxLink, {
        onClick: function() {
            return analytics/* default.fireEvent */.Z.fireEvent(googleAnalyticsTrackingOnClick);
        },
        href: boxLink,
        "aria-label": ariaLabel,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        minHeight: "234px",
        height: "100%",
        children: children
    });
};
function getContentfulPromoContent(promo) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6;
    var ref7 = (ref6 = (ref = promo.callsToAction) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref6 !== void 0 ? ref6 : {}, url = ref7.url, ariaLabel = ref7.ariaLabel, googleAnalyticsTracking = ref7.googleAnalyticsTracking;
    var _image;
    var promoImage = (_image = promo.image) !== null && _image !== void 0 ? _image : null;
    var ref8;
    var desktopFocalPoint = (ref8 = promoImage === null || promoImage === void 0 ? void 0 : promoImage.desktopFocalPoint) !== null && ref8 !== void 0 ? ref8 : "center";
    var ref9;
    var tabletFocalPoint = (ref9 = promoImage === null || promoImage === void 0 ? void 0 : promoImage.tabletFocalPoint) !== null && ref9 !== void 0 ? ref9 : "center";
    var promoImageUrl = promoImage === null || promoImage === void 0 ? void 0 : (ref1 = promoImage.asset) === null || ref1 === void 0 ? void 0 : ref1.file.url;
    return {
        headline: promo.headline,
        subheadline: promo.subheadline,
        mobileHeadline: promo.mobileHeadline,
        mobileSubheadline: promo.mobileSubheadline,
        disclaimer: promo.disclaimer,
        desktopImage: promoImageUrl ? "".concat(promoImageUrl, "?w=330&h=448&f=").concat(desktopFocalPoint, "&fit=fill") : "",
        tabletImage: promoImageUrl ? "".concat(promoImageUrl, "?w=660&h=224&f=").concat(tabletFocalPoint, "&fit=fill") : "",
        boxLink: url,
        ariaLabel: ariaLabel,
        googleAnalyticsTrackingOnView: {
            category: ((ref2 = promo.googleAnalyticsTracking) === null || ref2 === void 0 ? void 0 : ref2.category) || "promotion",
            action: (ref3 = promo.googleAnalyticsTracking) === null || ref3 === void 0 ? void 0 : ref3.action,
            label: (ref4 = promo.googleAnalyticsTracking) === null || ref4 === void 0 ? void 0 : ref4.label
        },
        googleAnalyticsTrackingOnClick: {
            category: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.category,
            action: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.action,
            label: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.label
        },
        borderTopColor: (ref5 = promo.theme) === null || ref5 === void 0 ? void 0 : ref5.borderColor
    };
}
function IncredibleTileDesktop() {
    var incredibleTilePromo = (0,useContentful/* default */.Z)("incredibleTile");
    var setiName = (0,useSeti/* default */.Z)(incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName, (incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName) !== undefined);
    var promo = (incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName) ? (0,getVariantContent/* default */.Z)(setiName, incredibleTilePromo) : incredibleTilePromo;
    var hasContentfulData = promo != null;
    var ref = hasContentfulData ? getContentfulPromoContent(promo) : IncredibleTile_content/* default */.Z, headline = ref.headline, subheadline = ref.subheadline, mobileHeadline = ref.mobileHeadline, mobileSubheadline = ref.mobileSubheadline, disclaimer = ref.disclaimer, desktopImage = ref.desktopImage, tabletImage = ref.tabletImage, boxLink = ref.boxLink, ariaLabel = ref.ariaLabel, googleAnalyticsTrackingOnClick = ref.googleAnalyticsTrackingOnClick, googleAnalyticsTrackingOnView = ref.googleAnalyticsTrackingOnView, borderTopColor = ref.borderTopColor;
    (0,react.useEffect)(function() {
        if ((googleAnalyticsTrackingOnView === null || googleAnalyticsTrackingOnView === void 0 ? void 0 : googleAnalyticsTrackingOnView.action) && (googleAnalyticsTrackingOnView === null || googleAnalyticsTrackingOnView === void 0 ? void 0 : googleAnalyticsTrackingOnView.label)) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: googleAnalyticsTrackingOnView.category,
                action: googleAnalyticsTrackingOnView.action,
                label: googleAnalyticsTrackingOnView.label
            });
        }
    }, [
        googleAnalyticsTrackingOnView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        boxShadowSize: "md",
        mr: [
            0,
            null,
            null
        ],
        borderRadius: "xl",
        borderWidth: 0,
        width: [
            1,
            null,
            1 / 3,
            null,
            "410px"
        ],
        color: "background.lightest",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBox, {
            boxLink: boxLink,
            googleAnalyticsTrackingOnClick: googleAnalyticsTrackingOnClick,
            ariaLabel: ariaLabel,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWithTopBorder, {
                flexDirection: [
                    "row",
                    null,
                    "column",
                    null,
                    "row"
                ],
                borderRadius: "xl",
                borderColor: borderTopColor || "primary.base",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                        xs: true,
                        sm: true,
                        xl: true,
                        xx: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImageOnTop, {
                            height: "115px",
                            image: tabletImage,
                            borderRadius: "lg",
                            rounded: "top"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        height: "100%",
                        width: 1,
                        px: 3,
                        pt: 2,
                        pb: 0,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        fontSize: 5,
                                        color: "primary",
                                        fontWeight: "bold",
                                        lineHeight: "36px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                                xs: true,
                                                sm: true,
                                                "data-testid": "desktop-incredible-headline",
                                                children: headline
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                                md: true,
                                                lg: true,
                                                xl: true,
                                                xxl: true,
                                                "data-testid": "mobile-incredible-headline",
                                                children: mobileHeadline || headline
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        fontSize: 1,
                                        color: "text",
                                        mt: 2,
                                        lineHeight: "24px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                                xs: true,
                                                sm: true,
                                                "data-testid": "desktop-incredible-subheadline",
                                                children: subheadline
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                                md: true,
                                                lg: true,
                                                xl: true,
                                                xxl: true,
                                                "data-testid": "mobile-incredible-subheadline",
                                                children: mobileSubheadline || subheadline
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasContentfulData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: [
                                    20,
                                    null,
                                    null,
                                    "auto"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                                    color: "darkGray",
                                    fontSize: 11,
                                    body: disclaimer
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "darkGray",
                                fontSize: "11px",
                                mb: 3,
                                children: disclaimer
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                        md: true,
                        lg: true,
                        width: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImageOnRight, {
                            height: "100%",
                            image: desktopImage
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/useFeature/useFeature.js
var useFeature = __webpack_require__(66252);
;// CONCATENATED MODULE: ./src/components/PromoFeatureBox.tsx



function PromoFeatureBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n"
    ]);
    PromoFeatureBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var HighlightedFlexStyle = (0,styled_components_browser_esm/* default */.ZP)(HighlightedFlex/* HighlightedFlex */.z).withConfig({
    componentId: "sc-c59ed9fd-0"
})(PromoFeatureBox_templateObject());
function PromoFeatureBox() {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _signInStatus = ref.signInStatus, _signedIn = _signInStatus.signedIn, signedIn = _signedIn === void 0 ? false : _signedIn;
    var heroSpacing = isMobile ? {
        my: [
            1,
            null,
            4
        ]
    } : {
        mt: [
            1,
            null,
            null,
            -4,
            0
        ],
        mb: [
            1,
            null,
            4
        ],
        style: {
            position: "relative"
        }
    };
    var highlightColor = (0,useFeature/* default */.Z)("siteExperience.highlightColor");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        mx: "auto",
        justifyContent: "center"
    }, heroSpacing), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedFlexStyle, {
            shadowOffsetX: 24,
            shadowOffsetY: 24,
            maxWidth: 1216,
            flexWrap: [
                "wrap",
                null,
                "unset"
            ],
            shadowColor: highlightColor,
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTileMobile, {
                        contentFulFieldID: "incredibleTileMobile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: 4,
                        children: signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPPromo, {
                            isMobile: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricebreakersPromo, {
                            isMobile: true
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* default */.ZP, {
                experimentCode: "HP_DT_MEDIACARDS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Original */.gg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPPromo, {
                                    isMobile: isMobile
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PricebreakersPromo, {
                                    isMobile: isMobile
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTileDesktop, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPPromoMediaCard, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBreakersMediaCard, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTile, {
                                    contentFulFieldID: "incredibleTile"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
}


/***/ }),

/***/ 92533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IncredibleTileMobile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67113);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77072);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21477);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70609);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87709);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23720);
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61388);
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57931);
/* harmony import */ var _pcln_contentful_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91378);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94738);
/* harmony import */ var _hooks_useSeti__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39939);
/* harmony import */ var _content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31266);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 6px solid ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: flex-start;\n  height: 100%;\n  object-fit: cover;\n  object-position: -40px;\n  position: relative;\n  border-radius: 0px 12px 16px 0px;\n  right: 0;\n  background-color: #fff;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  flex-shrink: 0;\n  object-fit: cover;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #fff;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  min-height: 234px;\n  &:hover {\n    text-decoration: none !important;\n    color: inherit;\n    overflow: visible;\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 6px 0px,\n      rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;\n    border-width: 1px;\n    border-color: rgb(192, 202, 213);\n    border-image: initial;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var FlexWithTopBorder = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da6f8d1-0"
})(_templateObject(), function(props) {
    return (0,pcln_design_system__WEBPACK_IMPORTED_MODULE_8__/* .getPaletteColor */ .ow)(props.borderColor)(props);
});
var BackgroundImageOnRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da6f8d1-1"
})(_templateObject1());
var BackgroundImageOnTop = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da6f8d1-2"
})(_templateObject2());
var BoxLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da6f8d1-3"
})(_templateObject3());
var PromoBox = function(param) {
    var children = param.children, boxLink = param.boxLink, ariaLabel = param.ariaLabel, googleAnalyticsTrackingOnClick = param.googleAnalyticsTrackingOnClick;
    return boxLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxLink, {
        onClick: function() {
            return _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent(googleAnalyticsTrackingOnClick);
        },
        href: boxLink,
        "aria-label": ariaLabel,
        children: children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        minHeight: "234px",
        height: "100%",
        children: children
    });
};
function getContentfulPromoContent(promo) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6;
    var ref7 = (ref6 = (ref = promo.callsToAction) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref6 !== void 0 ? ref6 : {}, url = ref7.url, ariaLabel = ref7.ariaLabel, googleAnalyticsTracking = ref7.googleAnalyticsTracking;
    var _image;
    var promoImage = (_image = promo.image) !== null && _image !== void 0 ? _image : null;
    var ref8;
    var desktopFocalPoint = (ref8 = promoImage === null || promoImage === void 0 ? void 0 : promoImage.desktopFocalPoint) !== null && ref8 !== void 0 ? ref8 : "center";
    var ref9;
    var tabletFocalPoint = (ref9 = promoImage === null || promoImage === void 0 ? void 0 : promoImage.tabletFocalPoint) !== null && ref9 !== void 0 ? ref9 : "center";
    var promoImageUrl = promoImage === null || promoImage === void 0 ? void 0 : (ref1 = promoImage.asset) === null || ref1 === void 0 ? void 0 : ref1.file.url;
    return {
        headline: promo.headline,
        subheadline: promo.subheadline,
        mobileHeadline: promo.mobileHeadline,
        mobileSubheadline: promo.mobileSubheadline,
        disclaimer: promo.disclaimer,
        desktopImage: promoImageUrl ? "".concat(promoImageUrl, "?w=330&h=448&f=").concat(desktopFocalPoint, "&fit=fill") : "",
        tabletImage: promoImageUrl ? "".concat(promoImageUrl, "?w=660&h=224&f=").concat(tabletFocalPoint, "&fit=fill") : "",
        boxLink: url,
        ariaLabel: ariaLabel,
        googleAnalyticsTrackingOnView: {
            category: ((ref2 = promo.googleAnalyticsTracking) === null || ref2 === void 0 ? void 0 : ref2.category) || "promotion",
            action: (ref3 = promo.googleAnalyticsTracking) === null || ref3 === void 0 ? void 0 : ref3.action,
            label: (ref4 = promo.googleAnalyticsTracking) === null || ref4 === void 0 ? void 0 : ref4.label
        },
        googleAnalyticsTrackingOnClick: {
            category: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.category,
            action: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.action,
            label: googleAnalyticsTracking === null || googleAnalyticsTracking === void 0 ? void 0 : googleAnalyticsTracking.label
        },
        borderTopColor: (ref5 = promo.theme) === null || ref5 === void 0 ? void 0 : ref5.borderColor
    };
}
function IncredibleTileMobile(param) {
    var incredibleTileContentfulName = param.incredibleTileContentfulName;
    var incredibleTilePromo = (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(incredibleTileContentfulName);
    var setiName = (0,_hooks_useSeti__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName, (incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName) !== undefined);
    var promo = (incredibleTilePromo === null || incredibleTilePromo === void 0 ? void 0 : incredibleTilePromo.experimentName) ? (0,_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(setiName, incredibleTilePromo) : incredibleTilePromo;
    var hasContentfulData = promo != null;
    var ref = hasContentfulData ? getContentfulPromoContent(promo) : _content__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, headline = ref.headline, subheadline = ref.subheadline, mobileHeadline = ref.mobileHeadline, mobileSubheadline = ref.mobileSubheadline, disclaimer = ref.disclaimer, desktopImage = ref.desktopImage, tabletImage = ref.tabletImage, boxLink = ref.boxLink, ariaLabel = ref.ariaLabel, googleAnalyticsTrackingOnClick = ref.googleAnalyticsTrackingOnClick, googleAnalyticsTrackingOnView = ref.googleAnalyticsTrackingOnView, borderTopColor = ref.borderTopColor;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((googleAnalyticsTrackingOnView === null || googleAnalyticsTrackingOnView === void 0 ? void 0 : googleAnalyticsTrackingOnView.action) && (googleAnalyticsTrackingOnView === null || googleAnalyticsTrackingOnView === void 0 ? void 0 : googleAnalyticsTrackingOnView.label)) {
            _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fireEvent */ .Z.fireEvent({
                category: googleAnalyticsTrackingOnView.category,
                action: googleAnalyticsTrackingOnView.action,
                label: googleAnalyticsTrackingOnView.label
            });
        }
    }, [
        googleAnalyticsTrackingOnView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        boxShadowSize: "md",
        mr: [
            0,
            null,
            null
        ],
        ml: [
            0,
            null,
            3
        ],
        borderRadius: "xl",
        borderWidth: 0,
        width: [
            1,
            null,
            1 / 3,
            null,
            "410px"
        ],
        color: "background.lightest",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PromoBox, {
            boxLink: boxLink,
            googleAnalyticsTrackingOnClick: googleAnalyticsTrackingOnClick,
            ariaLabel: ariaLabel,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FlexWithTopBorder, {
                flexDirection: [
                    "row",
                    null,
                    "column",
                    null,
                    "row"
                ],
                borderRadius: "xl",
                borderColor: borderTopColor || "primary.base",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        xs: true,
                        sm: true,
                        xl: true,
                        xx: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImageOnTop, {
                            height: "115px",
                            image: tabletImage,
                            borderRadius: "lg",
                            rounded: "top"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        flexDirection: "column",
                        height: "100%",
                        width: 1,
                        px: 3,
                        pt: 2,
                        pb: 0,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                        fontSize: 5,
                                        color: "primary",
                                        fontWeight: "bold",
                                        lineHeight: "36px",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                xs: true,
                                                sm: true,
                                                "data-testid": "desktop-incredible-headline",
                                                children: headline
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                md: true,
                                                lg: true,
                                                xl: true,
                                                xxl: true,
                                                "data-testid": "mobile-incredible-headline",
                                                children: mobileHeadline || headline
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                        fontSize: 1,
                                        color: "text",
                                        mt: 2,
                                        lineHeight: "24px",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                xs: true,
                                                sm: true,
                                                "data-testid": "desktop-incredible-subheadline",
                                                children: subheadline
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                md: true,
                                                lg: true,
                                                xl: true,
                                                xxl: true,
                                                "data-testid": "mobile-incredible-subheadline",
                                                children: mobileSubheadline || subheadline
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasContentfulData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                mt: [
                                    20,
                                    null,
                                    null,
                                    "auto"
                                ],
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pcln_contentful_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    color: "darkGray",
                                    fontSize: 11,
                                    body: disclaimer
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                                color: "darkGray",
                                fontSize: "11px",
                                mb: 3,
                                children: disclaimer
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        md: true,
                        lg: true,
                        width: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImageOnRight, {
                            height: "100%",
                            image: desktopImage
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 31266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _images_promos_hotel_image_2x_jpg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83326);
/* harmony import */ var _images_promos_hotel_image_2x_jpg__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_images_promos_hotel_image_2x_jpg__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _images_promos_hotel_image_tablet_2x_jpg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17544);
/* harmony import */ var _images_promos_hotel_image_tablet_2x_jpg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_images_promos_hotel_image_tablet_2x_jpg__WEBPACK_IMPORTED_MODULE_1__);


var CONTENT = {
    headline: "10% off coupon",
    mobileHeadline: "10% off coupon",
    mobileSubheadline: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    subheadline: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    disclaimer: "Coupon emailed after trip.",
    boxLink: null,
    desktopImage: (_images_promos_hotel_image_2x_jpg__WEBPACK_IMPORTED_MODULE_0___default()),
    desktopImageWebP: "".concat((_images_promos_hotel_image_2x_jpg__WEBPACK_IMPORTED_MODULE_0___default()), "?format=webp"),
    tabletImage: (_images_promos_hotel_image_tablet_2x_jpg__WEBPACK_IMPORTED_MODULE_1___default()),
    tabletImageWebP: "".concat((_images_promos_hotel_image_tablet_2x_jpg__WEBPACK_IMPORTED_MODULE_1___default()), "?format=webp"),
    ariaLabel: "Incredible Tile Promo",
    googleAnalyticsTrackingOnView: {
        action: null,
        category: null,
        label: null
    },
    googleAnalyticsTrackingOnClick: {
        category: "promotion",
        action: "weekly-2021",
        label: "HOMEPAGE|promo-right|inc-tile-default"
    },
    borderTopColor: null,
    heading: "10% off coupon",
    subheading: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    overline: null,
    media: null,
    primaryCallToAction: null
};
/* harmony default export */ __webpack_exports__["Z"] = (CONTENT);


/***/ }),

/***/ 10441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MarketingTout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/getVariantContent/getVariantContent.js
var getVariantContent = __webpack_require__(57931);
// EXTERNAL MODULE: ./src/assets/images/promos/marketing-tout.jpg
var marketing_tout = __webpack_require__(45626);
var marketing_tout_default = /*#__PURE__*/__webpack_require__.n(marketing_tout);
;// CONCATENATED MODULE: ./src/constants/promotions/marketing-tout.ts

/* harmony default export */ var promotions_marketing_tout = ({
    gaAction: "marketing tout cta",
    smallHeadingText: "THE EASIEST WAY TO SAVE",
    headingText: "Become an Email Insider",
    contentText: "Unlock exclusive coupons, early access to sales and more when you sign up for Priceline emails",
    alt: "",
    image: "".concat((marketing_tout_default()), "?opto=true&auto=webp"),
    buttons: [
        {
            gaLabel: "email sign up",
            buttonText: "Sign Up",
            linkUrl: "https://www.priceline.com/partner/email/signup"
        }
    ]
});

// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/components/GenericBanner/index.ts + 1 modules
var GenericBanner = __webpack_require__(90482);
// EXTERNAL MODULE: ./src/components/MerchModuleWrapper/index.ts + 3 modules
var MerchModuleWrapper = __webpack_require__(14229);
;// CONCATENATED MODULE: ./src/components/Promos/MarketingTout/MarketingTout.tsx








function MarketingTout() {
    var marketingTout = (0,useContentful/* default */.Z)("marketingTout");
    var setiName = (0,useSeti/* default */.Z)(marketingTout === null || marketingTout === void 0 ? void 0 : marketingTout.experimentName, (marketingTout === null || marketingTout === void 0 ? void 0 : marketingTout.experimentName) !== undefined);
    var marketingToutData = (marketingTout === null || marketingTout === void 0 ? void 0 : marketingTout.experimentName) ? (0,getVariantContent/* default */.Z)(setiName, marketingTout) : marketingTout;
    return marketingTout != null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModuleWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, marketingToutData)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericBanner/* default */.Z, {
        content: promotions_marketing_tout
    });
}


/***/ }),

/***/ 65781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RotatingBanner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77072);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92591);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  51% { opacity: 0; }\n  100% { opacity: 0; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        " 8s infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        " 8s 4s infinite;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  background-size: contain;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var rotateText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var FlexWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-0"
})(_templateObject1());
var PrimaryBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-5a895b37-1"
})(_templateObject2(), rotateText);
var SecondaryBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-2"
})(_templateObject3(), rotateText);
var StyledBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5a895b37-3"
})(_templateObject4());
function RotatingBanner(_param) {
    var image = _param.image, primaryBannerText = _param.primaryBannerText, secondaryBannerText = _param.secondaryBannerText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "image",
        "primaryBannerText",
        "secondaryBannerText"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FlexWrapper, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PrimaryBanner, {
                color: "primary",
                fontWeight: "normal",
                children: [
                    primaryBannerText,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SecondaryBanner, {
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        color: "primary",
                        fontWeight: "normal",
                        children: secondaryBannerText
                    }),
                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        mx: 3,
                        width: "310px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBackgroundImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            image: "".concat(image, "?opto&auto=webp")
                        }, props))
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 75755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HG": function() { return /* binding */ FlightsBumper; },
/* harmony export */   "IQ": function() { return /* binding */ CarsBumper; },
/* harmony export */   "UB": function() { return /* binding */ VacationBumper; },
/* harmony export */   "d7": function() { return /* binding */ CruiseBumper; },
/* harmony export */   "np": function() { return /* binding */ HotelsBumper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67113);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8316);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23720);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40869);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(92833);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87379);
/* harmony import */ var _components_RotatingBanner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65781);
/* harmony import */ var _images_airlines_flights_logo_bumper_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15205);
/* harmony import */ var _images_airlines_flights_logo_bumper_jpg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_airlines_flights_logo_bumper_jpg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_rental_cars_rcBumper_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34696);
/* harmony import */ var _images_rental_cars_rcBumper_png__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_rental_cars_rcBumper_png__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77185);
/* harmony import */ var _components_Flights_ExpressDeal_ExpressDealModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84469);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66487);
/* harmony import */ var _context_SearchFormContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51069);
/* harmony import */ var _Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84822);
/* harmony import */ var _ConditionalRender__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93314);
/* eslint-disable react/jsx-pascal-case */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).attrs(function() {
    return {
        p: 3
    };
}).withConfig({
    componentId: "sc-bc9e0d1f-0"
})(_templateObject(), (0,pcln_design_system__WEBPACK_IMPORTED_MODULE_14__/* .getPaletteColor */ .ow)("border.base"));
function FlightsBumper() {
    var ref = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), isOpen = ref.isOpen, openModal = ref.openModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            color: "transparent",
            onClick: openModal,
            p: 0,
            width: 1,
            "aria-label": "Save up to 50% by searching Express Deals.",
            "data-testid": "flight-express-deal-bumper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Flights_ExpressDeal_ExpressDealModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    isModalOpen: isOpen,
                    gaCategory: _constants_analytics__WEBPACK_IMPORTED_MODULE_8__/* .ANALYTICS_CATEGORY_HOME */ .DG
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_RotatingBanner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    height: "25px",
                    image: (_images_airlines_flights_logo_bumper_jpg__WEBPACK_IMPORTED_MODULE_4___default()),
                    primaryBannerText: "Save up to 50% by searching Express Deals.",
                    secondaryBannerText: "Trusted airlines, incredible deals."
                })
            ]
        })
    });
}
function CarsBumper() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_RotatingBanner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            height: "25px",
            image: (_images_rental_cars_rcBumper_png__WEBPACK_IMPORTED_MODULE_5___default()),
            primaryBannerText: "Save up to 40% by searching Express Deals.",
            secondaryBannerText: "Trusted brands, incredible deals."
        })
    });
}
function VacationBumper() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
            fontSize: 1,
            textAlign: "center",
            color: "text.light",
            children: "Save up to $625 when you book your hotel and flight together!"
        })
    });
}
function CruiseBumper() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
            fontSize: 1,
            textAlign: "center",
            color: "text.light",
            children: [
                "Get up to $1,000 to spend at sea when you\xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span */ .ZP.span, {
                    fontWeight: "bold",
                    color: "primary",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        href: "https://cruises.priceline.com?utm_medium=partner_site_banner&utm_source=pcln-partner_site&utm_campaign=20190307&utm_content=widget_link",
                        target: "_blank",
                        children: "book a cruise with Priceline."
                    })
                })
            ]
        })
    });
}
function HotelsBumper() {
    var formValues = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_SearchFormContext__WEBPACK_IMPORTED_MODULE_9__/* .SearchFormContext */ .j).formValues;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ConditionalRender__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        experimentCode: "PKG_FE_HOTEL_HOTEL_LANDING",
        variantValue: "VARIANT",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ConditionalRender__WEBPACK_IMPORTED_MODULE_11__/* .Experiment */ .KS, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .ZP, {
                    fontSize: 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        flexWrap: "wrap",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ConditionalRender__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                            experimentCode: "PKG_FE_IMPROVE_MULTI_HOTEL_COPYING",
                            variantValue: "VARIANT",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_ConditionalRender__WEBPACK_IMPORTED_MODULE_11__/* .Original */ .gg, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span */ .ZP.span, {
                                            color: "text.light",
                                            children: "On a multi-destination trip?\xa0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span */ .ZP.span, {
                                            fontWeight: "bold",
                                            color: "primary",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                href: (0,_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_10__/* .formatShopSearchLink */ .Uo)(formValues),
                                                target: "_blank",
                                                children: "Book up to five hotel stays"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ConditionalRender__WEBPACK_IMPORTED_MODULE_11__/* .Experiment */ .KS, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_16__/* ["default"].span */ .ZP.span, {
                                        fontWeight: "bold",
                                        color: "primary",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            href: (0,_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_10__/* .formatShopSearchLink */ .Uo)(formValues),
                                            target: "_blank",
                                            children: "Book up to 5 hotels at the same time"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 67685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RN": function() { return /* binding */ AMENITIES; },
/* harmony export */   "bW": function() { return /* binding */ PRODUCT_TABS; },
/* harmony export */   "ob": function() { return /* binding */ HEADERS; }
/* harmony export */ });
var PRODUCT_TABS = [
    {
        autobotID: "DASH_TAB_HOTELS",
        name: "HOTELS",
        tabText: "Hotels",
        id: "hotels",
        query: {
            tab: "hotels"
        }
    },
    {
        autobotID: "DASH_TAB_FLIGHTS",
        name: "FLIGHTS",
        tabText: "Flights",
        id: "flights",
        query: {
            tab: "flights"
        }
    },
    {
        autobotID: "DASH_TAB_HOTEL + FLIGHT",
        name: "BUNDLE + SAVE",
        tabText: "Bundle & Save",
        id: "vacations",
        query: {
            tab: "vacations"
        }
    },
    {
        autobotID: "DASH_TAB_CARS",
        name: "CARS",
        tabText: "Cars",
        id: "cars",
        query: {
            tab: "cars"
        }
    },
    {
        autobotID: "DASH_TAB_CRUISES",
        name: "CRUISES",
        tabText: "Cruises",
        id: "cruises",
        query: {
            tab: "cruises"
        }
    }
];
var HEADERS = {
    hotels: {
        headline: "Save more on your next hotel",
        subheadline: "Thousands of deals made every day"
    },
    flights: {
        headline: "Save more on your next flight",
        subheadline: "Thousands of deals made every day"
    },
    vacations: {
        headline: "Save up to $625 on your hotel and flight",
        subheadline: "Book together for our best deals"
    },
    cars: {
        headline: "Save more on your next rental car",
        subheadline: "Thousands of deals made every day"
    },
    cruises: {
        headline: "Save more on your next cruise",
        subheadline: "Thousands of deals made every day"
    }
};
var AMENITIES = {
    AIRSHUTTL: "Search Hotels with Airport Shuttles",
    CASINO: "Search Hotels with Casinos",
    FBRKFST: "Search Hotels with Free Breakfast",
    FINTRNT: "Search Hotels with Free Internet",
    FITSPA: "Search Hotels with Gyms",
    FPRKING: "Search Hotels with Free Parking",
    INCLUSIVE: "Search All Inclusive Hotels",
    KITCHEN: "Search Hotels with Kitchens",
    PETALLOW: "Search Pet Friendly Hotels",
    SPOOL: "Search Hotels with Swimming Pools",
    RESTRNT: "Search Hotels with Restaurants",
    SPA: "Search Hotels with Spas"
};


/***/ }),

/***/ 10740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SmsOptInComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/sms-opt-in/dist/esm/index.js + 7 modules
var esm = __webpack_require__(65939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var dist_esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(dist_esm);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/utils/queries/smsOptIn.ts
var SMS_DISCLAIMER_TEXT_QUERY = "\nquery smsDisclaimerText ($disclaimerBaseParam: DisclaimerBaseParam!) {\n  smsDisclaimerText(disclaimerBaseParam: $disclaimerBaseParam) {\n    message\n    status\n      disclaimers {\n        optinStatus\n        disclaimerText {\n          text\n          url\n        }\n      }\n    }\n}\n";
var SMS_SUBMIT_NO_EMAIL_MUTATION = "mutation smsSubscriptionByPhoneNumber ($phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {\n    smsSubscriptionByPhoneNumber (phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {\n      message\n      status\n    }\n  }";
var SMS_SUBMIT_WITH_EMAIL_MUTATION = "mutation smsSubscriptionByEmailAddress ($emailAddress: String!, $phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {\n  smsSubscriptionByEmailAddress (emailAddress: $emailAddress, phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {\n    message\n    status\n  }\n}";

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/hooks/smsOptIn/useGetDisclaimer.ts









var useGetDisclaimer = function(baseParams) {
    var ref = (0,react.useState)([]), disclaimers = ref[0], setDisclaimers = ref[1];
    var ref1 = (0,react.useContext)(BootstrapDataContext/* default */.Z), clientGUID = ref1.webstats.clientGUID;
    (0,react.useEffect)(function() {
        function fetchSmsDisclaimer() {
            return _fetchSmsDisclaimer.apply(this, arguments);
        }
        function _fetchSmsDisclaimer() {
            _fetchSmsDisclaimer = (0,_async_to_generator/* default */.Z)(function() {
                var ref, url, timeout, response, _data, errors, data, errorMessage, ref1, error, errorMessage1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                            return [
                                4,
                                esm_default()({
                                    url: url,
                                    timeout: timeout,
                                    method: "POST",
                                    data: {
                                        query: SMS_DISCLAIMER_TEXT_QUERY,
                                        variables: baseParams
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            _data = response.data, errors = _data.errors, data = _data.data;
                            if (Array.isArray(errors) && errors.length > 0) {
                                errorMessage = (0,_instanceof/* default */.Z)(errors, Error) ? errors.message : errors.toString();
                                analytics/* default.logError */.Z.logError({
                                    message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, " Error message: ").concat(errorMessage)
                                });
                                return [
                                    2
                                ];
                            }
                            if (data) {
                                ;
                                // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
                                analytics/* default.log */.Z.log({
                                    message: "Fetched disclaimer for cGuid: ".concat(clientGUID)
                                });
                                setDisclaimers((ref1 = data.smsDisclaimerText) === null || ref1 === void 0 ? void 0 : ref1.disclaimers);
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            errorMessage1 = (0,_instanceof/* default */.Z)(error, Error) ? error.message : error.toString();
                            analytics/* default.logError */.Z.logError({
                                message: "Failed to query for SMS disclaimer text for cGuid: ".concat(clientGUID, ". Error message: ").concat(errorMessage1)
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchSmsDisclaimer.apply(this, arguments);
        }
        fetchSmsDisclaimer();
    }, [
        baseParams,
        clientGUID
    ]);
    return disclaimers;
};
/* harmony default export */ var smsOptIn_useGetDisclaimer = (useGetDisclaimer);

;// CONCATENATED MODULE: ./src/hooks/smsOptIn/useSubmitSmsOptIn.ts







function isEmailResponse(data, emailAddress) {
    return !!emailAddress;
}
var fireAnalytics = function(label) {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "sms signup",
        category: "pcln_home",
        label: label
    });
};
function handleSubmit(_) {
    return _handleSubmit.apply(this, arguments);
}
function _handleSubmit() {
    _handleSubmit = (0,_async_to_generator/* default */.Z)(function(param) {
        var emailAddress, formData, disclaimerText, baseParams, setSignUpState, setSignUpSubmitFailureMessage, clientGUID, createSubmission, ref, url, timeout, response, _data, errors, data, status, message, ref1, ref2, ref3, ref4, error, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    emailAddress = param.emailAddress, formData = param.formData, disclaimerText = param.disclaimerText, baseParams = param.baseParams, setSignUpState = param.setSignUpState, setSignUpSubmitFailureMessage = param.setSignUpSubmitFailureMessage, clientGUID = param.clientGUID;
                    setSignUpState("SIGN_UP_IN_PROGRESS");
                    createSubmission = function() {
                        return emailAddress ? {
                            emailAddress: emailAddress,
                            phoneCountryCode: formData.phoneCountryCode,
                            phoneNumber: formData.phoneNumber,
                            subscriptionBaseParam: {
                                subscriptionTypeId: 1,
                                disclaimerText: disclaimerText,
                                subscriptionStatus: true,
                                placement: baseParams.disclaimerBaseParam.placement,
                                appCode: baseParams.disclaimerBaseParam.appCode,
                                plfCode: baseParams.disclaimerBaseParam.PLFCode
                            }
                        } : {
                            phoneCountryCode: formData.phoneCountryCode,
                            phoneNumber: formData.phoneNumber,
                            subscriptionBaseParam: {
                                subscriptionTypeId: 1,
                                disclaimerText: disclaimerText,
                                subscriptionStatus: true,
                                placement: baseParams.disclaimerBaseParam.placement,
                                appCode: baseParams.disclaimerBaseParam.appCode,
                                plfCode: baseParams.disclaimerBaseParam.PLFCode
                            }
                        };
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                    return [
                        4,
                        esm_default()({
                            url: url,
                            timeout: timeout,
                            method: "POST",
                            data: {
                                query: emailAddress ? SMS_SUBMIT_WITH_EMAIL_MUTATION : SMS_SUBMIT_NO_EMAIL_MUTATION,
                                variables: createSubmission()
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    _data = response.data, errors = _data.errors, data = _data.data;
                    status = "";
                    message = "";
                    if (data) {
                        ;
                        status = isEmailResponse(data, emailAddress) ? (ref1 = data.smsSubscriptionByEmailAddress) === null || ref1 === void 0 ? void 0 : ref1.status : (ref2 = data.smsSubscriptionByPhoneNumber) === null || ref2 === void 0 ? void 0 : ref2.status;
                        message = isEmailResponse(data, emailAddress) ? (ref3 = data.smsSubscriptionByEmailAddress) === null || ref3 === void 0 ? void 0 : ref3.message : (ref4 = data.smsSubscriptionByPhoneNumber) === null || ref4 === void 0 ? void 0 : ref4.message;
                    }
                    if (Array.isArray(errors) && errors.length > 0) {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        fireAnalytics("invalid");
                        setSignUpState("SIGN_UP_ERROR");
                        return [
                            2
                        ];
                    }
                    if (status === "BAD_REQUEST") {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        setSignUpSubmitFailureMessage(message);
                        fireAnalytics("invalid");
                        setSignUpState("NOT_SIGNED_UP");
                        return [
                            2
                        ];
                    }
                    if (status !== "SUCCESS" && status !== "PENDING") {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        fireAnalytics("invalid");
                        setSignUpState("SIGN_UP_ERROR");
                        return [
                            2
                        ];
                    }
                    // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
                    analytics/* default.log */.Z.log({
                        message: "Successful SMS subscription for cGuid: ".concat(clientGUID, " status: ").concat(status)
                    });
                    fireAnalytics("valid");
                    setSignUpState("SIGNED_UP");
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = (0,_instanceof/* default */.Z)(error, Error) ? error.message : error.toString();
                    analytics/* default.logError */.Z.logError({
                        message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, " Error message: ").concat(errorMessage)
                    });
                    fireAnalytics("invalid");
                    setSignUpState("SIGN_UP_ERROR");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleSubmit.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/SmsOptIn/index.tsx







var imageUrl = "https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=3:2,smart";
var altImageText = "business man in car";
var smallImageUrl = "https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=2:3,smart";
var smallImageAltText = "business man in car";
var headline = "NEW: Get savings texted to you directly!";
var subheadline = "Provide your phone number and we'll send you special deals and promotions via SMS.";
var baseParamsMobile = {
    disclaimerBaseParam: {
        placement: "HOMEPAGE",
        appCode: "MOBILEWEB",
        classification: "PROMOTIONAL",
        PLFCode: "PCLN"
    }
};
var baseParamsDesktop = {
    disclaimerBaseParam: {
        placement: "HOMEPAGE",
        appCode: "DESKTOP",
        classification: "PROMOTIONAL",
        PLFCode: "PCLN"
    }
};
function SmsOptInComponent() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _customer = ref2.customer, _emailAddress = _customer.emailAddress, emailAddress = _emailAddress === void 0 ? "" : _emailAddress, isMobile = ref2.isMobile, clientGUID = ref2.webstats.clientGUID;
    var baseParams = isMobile ? baseParamsMobile : baseParamsDesktop;
    var disclaimers = smsOptIn_useGetDisclaimer(baseParams);
    var ref3 = (0,react.useState)("NOT_SIGNED_UP"), signUpState = ref3[0], setSignUpState = ref3[1];
    var ref4 = (0,react.useState)(""), signUpSubmitFailureMessage = ref4[0], setSignUpSubmitFailureMessage = ref4[1];
    var validDisclaimer = disclaimers === null || disclaimers === void 0 ? void 0 : disclaimers.find(function(disclaimer) {
        return !disclaimer.optinStatus;
    });
    var disclaimerText = validDisclaimer === null || validDisclaimer === void 0 ? void 0 : (ref = validDisclaimer.disclaimerText) === null || ref === void 0 ? void 0 : ref.reduce(function(previousValue, currentValue) {
        return previousValue + currentValue.text;
    }, "");
    var disclaimerTextNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: validDisclaimer === null || validDisclaimer === void 0 ? void 0 : (ref1 = validDisclaimer.disclaimerText) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
            var text = param.text, url = param.url;
            var uniqueKey = isMobile ? "m".concat(index) : "d".concat(index);
            return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: url,
                target: "blank",
                children: text
            }, uniqueKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: text
            }, uniqueKey);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 1280,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            borderRadius: "xl",
            mx: [
                0,
                null,
                null,
                null,
                4
            ],
            mt: [
                0,
                null,
                null,
                null,
                "40px"
            ],
            mb: [
                3,
                null,
                null,
                null,
                0
            ],
            p: 4,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                headline: headline,
                subheadline: subheadline,
                imageUrl: imageUrl,
                smallImageUrl: smallImageUrl,
                buttonSize: "large",
                textInputRadius: "lg",
                signUpState: signUpState,
                imageWidth: 1 / 3,
                formWidth: 2 / 3,
                disclaimerTextNode: disclaimerTextNode,
                handleFormSubmit: function(formData) {
                    return handleSubmit({
                        emailAddress: emailAddress,
                        formData: formData,
                        disclaimerText: disclaimerText || "",
                        baseParams: baseParams,
                        setSignUpState: setSignUpState,
                        setSignUpSubmitFailureMessage: setSignUpSubmitFailureMessage,
                        clientGUID: clientGUID
                    });
                },
                phoneInputErrorMessage: signUpSubmitFailureMessage,
                altImageText: altImageText,
                smallImageAltText: smallImageAltText
            })
        })
    });
}


/***/ }),

/***/ 66410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gL": function() { return /* binding */ GREETING_DESKTOP; }
/* harmony export */ });
/* unused harmony export GREETING_MOBILE */
var GREETING_MOBILE = "Welcome to Priceline";
var GREETING_DESKTOP = "Welcome to Priceline";
var Content = {
    homepage: {
        hotel: {
            signedInSubHeading: "You qualify for VIP hotel deals! Search and save.",
            expressDeals: {
                headline: "Search for Express Deals",
                subHeadline: "Save up to 60% Fast and Easy - No Bidding Required!"
            }
        },
        flights: {
            expressDeals: {
                headline: "Search for Express Deals",
                subHeadline: "Save up to 50% on trusted airlines!"
            }
        },
        vip: {
            defaultHeading: GREETING_MOBILE,
            headlineWithName: "Welcome, {firstName}",
            headlineWithNameQualify: "{firstName}, you qualify for VIP deals",
            headlineWithNameBigDeal: "{firstName}, find your big deal",
            promo: {
                headline: "You qualify for hotel discounts of up to 50% as a VIP member!",
                headlineWithName: "{firstName}, you qualify for hotel discounts of up to 50% as a VIP member!",
                subHeadline: "Book Priceline VIP deals for your exclusive savings"
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (Content);


/***/ }),

/***/ 40813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCityNameInFormHeadlineForSEM; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


function useCityNameInFormHeadlineForSEM(location) {
    var ref;
    var prePopData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).prePopData;
    var endLocation = prePopData === null || prePopData === void 0 ? void 0 : (ref = prePopData.hotels) === null || ref === void 0 ? void 0 : ref.endLocation;
    var hasCity = !!(endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName) && (endLocation === null || endLocation === void 0 ? void 0 : endLocation.type) === "CITY";
    return hasCity ? "Search ".concat((location === null || location === void 0 ? void 0 : location.cityName) || (endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName), " Hotels") : null;
}


/***/ }),

/***/ 77185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExpressDealModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77584);





function useExpressDealModal() {
    var qsKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "modal", qsValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "express-deals";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var query = router.query, pathname = router.pathname;
    var isOpen = query[qsKey] === qsValue;
    var openModal = function() {
        router.push({
            pathname: pathname,
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, query), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, qsKey, qsValue))
        }, undefined, {
            shallow: true
        });
    };
    var closeModal = function() {
        router.push({
            pathname: pathname,
            query: (0,ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
                qsKey
            ], query)
        }, undefined, {
            shallow: true
        });
    };
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}


/***/ }),

/***/ 83405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExtendStayBooking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


function useExtendStayBooking() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), mostRecentBooking = ref.mostRecentBooking, customer = ref.customer;
    var extendStayTrip = mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.current;
    return extendStayTrip ? {
        travelEndDateTime: extendStayTrip.travelEndDateTime,
        cityName: extendStayTrip.cityName,
        hotelID: extendStayTrip.hotelID,
        numRooms: extendStayTrip.numRooms,
        title: extendStayTrip.title,
        customerFirstName: customer.firstName
    } : null;
}


/***/ }),

/***/ 81850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMostRecentFutureBooking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92823);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60890);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45596);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50774);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);



var isTruthy = (0,ramda__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ramda__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, ramda__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z));
function useMostRecentFutureBooking() {
    var mostRecentBooking = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).mostRecentBooking;
    return isTruthy(mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.future) ? mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.future : null;
}


/***/ }),

/***/ 32881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSEMSearchHeadline; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_SearchForm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67685);


function useSEMSearchHeadline() {
    var ref;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().query;
    var SEMSearch = query.SEMSearch, SEMSEARCH = query.SEMSEARCH;
    var semSearchParam = (ref = SEMSearch || SEMSEARCH) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    return _components_SearchForm_constants__WEBPACK_IMPORTED_MODULE_1__/* .AMENITIES */ .RN[semSearchParam];
}


/***/ })

}]);